<template>
  <div class="dem-ger" :class="'dem-ger--' + cpntDemanda">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cabecalho">
        <App-Filtros
        :cpntMontarCampoF="demandaGerTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="demandaGerTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="demandaGerTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'id_con_nome', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='demandaGerTabBuscarLinhas'
        ref="filtros">
          <div class="botao" v-if="tabper !== '' && [ '', null, undefined ].indexOf(cpntSelecionar) !== -1 && mostrarBotaoNovaDemanda === true">
            <App-Button :data-time="time" 
              :cpntId='botao.id'
              :cpntStatus='botao.status' 
              :cpntIcone='botao.icone'
              :cpntTexto='nomeBotaoNovaDemanda'
              :cpntClass='botao.class'
              :cpntDisabled="botao.disabled"
              @onClick='botao.onClick'
            ></App-Button>
          </div>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntFiltros="$refs.filtros"
        :cpntSetarFiltros="demandaGerTabSetarFiltros"
        :cpntMontarFiltros="demandaGerTabMontarFiltros"
        :cpntMontarWhere="demandaGerTabTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntMostrarMper="true"
        :cpntBotaoExportar="exportar"
        :cpntBotaoExcluir="botaoExcluir"
        :cpntBotaoCopiar="botaoCopiar"
        :cpntSetarValores="demandaGerTabSetarLinhas"
        :cpntApiTabPer="tabper"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntSalvarEdicao="demandaGerTabEditar"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiField="field"
        :cpntApiOrder="order"
        :cpntApiFieldVirtual="fieldVir"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @cpntSetarStatusLiberado="demandaGerTabSetarStatusLiberado"
        @TABELA_MARCAR_CHECKBOX="demandaGerTabMarcarCheckbox"
        ref="tabela">
          <template slot="botoes2" v-if="($store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === true && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, null, null, null, null, false) === true) || $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === false">
            <App-Button :data-time="time" :cpntIcone="'far fa-money-bill-alt'" title="Clique aqui para gerar o relatorio consolidados por forma de pagamento" @onClick="demandaGerTabGerarRelatorioConsolidado"></App-Button>
          </template>

          <!-- COLUNA EDITAR -->
          <template v-slot:col_editar="{ linha }">
            <App-Button
              :cpntStatus='liberado === "" ? linha.vend_editar.status : liberado'
              :cpntIcone='linha.vend_editar.icone'
              :cpntClass='linha.vend_editar.class'
              @onClick='(cpntId) => { linha.vend_editar.onClick(linha.dem_alias, cpntId) }'
            ></App-Button>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:col_dem_ref="{ linha }">
            <!-- SETA O NUMERO DA DEMANDA -->
            <App-Button
              :cpntStatus='liberado === "" ? linha.demanda_ref_doc.status : liberado' 
              :cpntTexto='linha.demanda_ref_doc.texto'
              :cpntClass='linha.demanda_ref_doc.class'
              :cpntDisabled='linha.demanda_ref_doc.disabled'
              @onClick='(cpntId) => { linha.demanda_ref_doc.onClick(linha.dem_ref, cpntId) }'
            ></App-Button>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:col_dem_alias="{ linha }">
            <!-- SETA O NUMERO DA DEMANDA -->
            <App-Button
              :cpntStatus='liberado === "" ? linha.demanda_doc.status : liberado' 
              :cpntTexto='linha.demanda_doc.texto'
              :cpntClass='linha.demanda_doc.class'
              :cpntDisabled='linha.demanda_doc.disabled'
              @onClick='(cpntId) => { linha.demanda_doc.onClick(linha.dem_alias, cpntId) }'
            ></App-Button>
            
            <!-- VERIFICA SE TEM QUE CRIAR O CAMPO DA RECORRENCIA -->
            <App-Button v-if="linha.demanda_rec !== null" class="recorrencia"
              :cpntStatus='liberado === "" ? linha.demanda_rec.status : liberado' 
              :cpntIcone='linha.demanda_rec.icone'
              :cpntClass='linha.demanda_rec.class'
              @onClick='(cpntId) => { linha.demanda_rec.onClick(linha.id_rec, cpntId) }'
            ></App-Button>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:col_id_con="{ linha }">
            <App-Button v-if="linha.link_cadastro_con !== null"
              :cpntStatus='liberado === "" ? linha.link_cadastro_con.status : liberado' 
              :cpntClass='linha.link_cadastro_con.class'
              @onClick='() => { linha.link_cadastro_con.onClick("contato", linha.id_con) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.id_con_nome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='linha.id_con_pessoa === "j" && linha.id_con_empresa !== ""' v-html="' (' + linha.id_con_empresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.id_con_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>

            <!-- SETA O CONTEUDO SE NÃO TIVER BOTÃO -->
            <span v-else>&nbsp;</span>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:col_id_vei="{ linha }">
            <App-Button v-if="linha.link_cadastro_vei !== null"
              :cpntStatus='liberado === "" ? linha.link_cadastro_vei.status : liberado' 
              :cpntClass='linha.link_cadastro_vei.class'
              @onClick='() => { linha.link_cadastro_vei.onClick("veiculo", linha.id_vei) }'>
              <!-- COLOCA O NOME DO VEICULO -->
              <span v-html="linha.id_vei_placa"></span>

              <!-- COLOCA O MODELO NOVO DA API -->
              <template v-if="[ '', null, undefined ].indexOf(linha.id_vei_ref_modelo_id_marca_j_marca) === -1 || [ '', null, undefined ].indexOf(linha.id_vei_ref_modelo_j_modelo) === -1">
                <span v-if="[ '', null, undefined ].indexOf(linha.id_vei_ref_modelo_id_marca_j_marca) === -1" v-html="' ' + linha.id_vei_ref_modelo_id_marca_j_marca"></span>
                <span v-if="[ '', null, undefined ].indexOf(linha.id_vei_ref_modelo_j_modelo) === -1" v-html="' ' + linha.id_vei_ref_modelo_j_modelo"></span>
              </template>

              <!-- COLOCA O MODELO ANTIGO DA API-->
              <template v-else>
                <span v-if="[ '', null, undefined ].indexOf(linha.id_vei_id_mar_nome) === -1" v-html="' ' + linha.id_vei_id_mar_nome"></span>
                <span v-if="[ '', null, undefined ].indexOf(linha.id_vei_id_mod_nome) === -1" v-html="' ' + linha.id_vei_id_mod_nome"></span>
              </template>

              <!-- VERIFICA SE O VEICULO ESTA EXCLUIDO -->
              <b v-if='linha.id_vei_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>

            <!-- SETA O CONTEUDO SE NÃO TIVER BOTÃO -->
            <span v-else>&nbsp;</span>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:col_id_pet="{ linha }">
            <App-Button v-if="linha.link_cadastro_pet !== null"
              :cpntStatus='liberado === "" ? linha.link_cadastro_pet.status : liberado'
              :cpntClass='linha.link_cadastro_pet.class'
              @onClick='() => { linha.link_cadastro_pet.onClick("pet", linha.id_pet) }'>
              <!-- COLOCA O NOME DO PET -->
              <span v-html="linha.id_pet_nome"></span>

              <!-- COLOCA O NOME DO PET -->
              <span v-if="[ '', null, undefined ].indexOf(linha.id_pet_id_pet_subespecie_id_especie_j_especie) === -1" v-html="' (' + linha.id_pet_id_pet_subespecie_id_especie_j_especie + ' - '"></span>
              <span v-if="[ '', null, undefined ].indexOf(linha.id_pet_id_pet_subespecie_j_subespecie) === -1" v-html="linha.id_pet_id_pet_subespecie_j_subespecie + ')'"></span>

              <!-- VERIFICA SE O PET ESTA EXCLUIDO -->
              <b v-if='linha.id_pet_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>

            <!-- SETA O CONTEUDO SE NÃO TIVER BOTÃO -->
            <span v-else>&nbsp;</span>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:col_obs_cli="{ linha, indexL, valor }">
            <!-- COLOCA O BOTÃO -->
            <App-Button v-if="linha.obs_cli_bt !== null"
            :cpntId='linha.obs_cli_bt.id'
            :cpntStatus='liberado === "" ? linha.obs_cli_bt.status : liberado'
            :cpntTexto='linha.obs_cli_bt.texto'
            :cpntTipo='linha.obs_cli_bt.tipo'
            :cpntIcone='linha.obs_cli_bt.icone'
            :cpntClass='linha.obs_cli_bt.class'
            @onClick='() => { linha.obs_cli_bt.onClick(indexL) }'
            ></App-Button>

            <!-- COLOCA O CONTEUDO -->
            <span v-else v-html="valor"></span>
          </template>

          <template v-slot:col_obs_emp="{ linha, indexL, valor }">
            <!-- COLOCA O BOTÃO -->
            <App-Button v-if="linha.obs_emp_bt !== null"
            :cpntId='linha.obs_emp_bt.id'
            :cpntStatus='liberado === "" ? linha.obs_emp_bt.status : liberado'
            :cpntTexto='linha.obs_emp_bt.texto'
            :cpntTipo='linha.obs_emp_bt.tipo'
            :cpntIcone='linha.obs_emp_bt.icone'
            :cpntClass='linha.obs_emp_bt.class'
            @onClick='() => { linha.obs_emp_bt.onClick(indexL) }'
            ></App-Button>

            <!-- COLOCA O CONTEUDO -->
            <span v-else v-html="valor"></span>
          </template>

          <template v-slot:col_obs_nf_pro="{ linha, indexL, valor }">
            <!-- COLOCA O BOTÃO -->
            <App-Button v-if="linha.obs_nf_pro_bt !== null"
            :cpntId='linha.obs_nf_pro_bt.id'
            :cpntStatus='liberado === "" ? linha.obs_nf_pro_bt.status : liberado'
            :cpntTexto='linha.obs_nf_pro_bt.texto'
            :cpntTipo='linha.obs_nf_pro_bt.tipo'
            :cpntIcone='linha.obs_nf_pro_bt.icone'
            :cpntClass='linha.obs_nf_pro_bt.class'
            @onClick='() => { linha.obs_nf_pro_bt.onClick(indexL) }'
            ></App-Button>

            <!-- COLOCA O CONTEUDO -->
            <span v-else v-html="valor"></span>
          </template>

          <!-- SETA A DATA E HORA DA ULTIMA ATUALIZAÇÃO -->
          <template v-slot:col_last="{ linha }">
            <span v-html="linha.updated_user_usuario"></span>
          </template>

          <!-- SETA A DATA E HORA DA ULTIMA ATUALIZAÇÃO -->
          <template v-slot:col_id_pco_item="{ linha }">
            <table v-if="linha.status_processo !== null" @click="() => { demandaGerTabAbrirControleProcesso(linha) }">
              <tr>
                <td :style="'color: ' + linha.status_processo.cor_letra + '; background: ' + linha.status_processo.cor_fundo + ';'">
                  <span v-html="linha.status_processo.nome"></span>
                </td>
              </tr>
            </table>

            <!-- SETA O VALOR DA COLUNA -->
            <div v-else>---</div>
          </template>

          <template v-slot:col_n_nf_emitidas="{ linha, indexL }">
            <div v-if="[ '', null, undefined ].indexOf(linha.clu) === -1" :key="'nfemitida' + linha.n_nf_emitidas">
              <!-- FAZ A BUSCA DOS DADOS -->
              <App-Button v-if="[ '', null, undefined, 'carregando' ].indexOf(linha.n_nf_emitidas) !== -1" :cpntStatus="linha.n_nf_emitidas === 'carregando' ? linha.n_nf_emitidas : ''"
              @onClick='() => { demandaGerTabBuscarNfEmitidas(indexL, linha) }'>
                Nº D.F.M.A<br/>CLU: {{ linha.clu }}
              </App-Button>

              <!-- APRESENTA OS DADOS SOLICITADOS -->
              <span v-else v-html="linha.n_nf_emitidas"></span>
            </div>
          </template>

          <!-- SETA O ESTOQUE -->
          <template v-slot:col_estoque="{ linha }">
            <!-- VERIFICA SE DEVE INFORMAR O ICONE -->
            <div v-if="[ '', null, undefined ].indexOf(linha.estoque) === -1">
              <App-Icone :data-time='time' :cpntTipo='linha.estoque.icone' :cpntIconeClass='linha.estoque.class' :cpntExplica='linha.estoque.explica'></App-Icone>
            </div>

            <!-- SETA O VALOR DA COLUNA -->
            <div v-else>---</div>
          </template>

          <!-- SETA A COLUNA DE VALOR -->
          <template v-slot:col_valor="{ indexL, indexC, indexCV, linha }">
            <div @mouseover="demandaGerTabGerarQtipValor((indexCV + '--' + indexL + '--' + indexC), linha)">
              <div :ref="(indexCV + '--' + indexL + '--' + indexC)" v-html="linha.valor"></div>
            </div>
          </template>

          <!-- SETA DOCUMENTO DE PRODUTO -->
          <template v-slot:col_pro_doc="{ linha }">
            <!-- SETA O TIPO DE DOCUMENTO SELECIONADO -->
            <span v-if="linha.doc_produto === null">
              <span v-html="linha.p_doc_tp"></span>
              <template v-if="linha.p_doc_n !== ''">
                <br/>
                <span v-html="'nº ' + linha.p_doc_n"></span>
              </template>
            </span>

            <!-- MONTA OS BOTOES DAS NOTAS -->
            <div v-else>
              <App-Button
              :cpntStatus='liberado === "" ? linha.doc_produto.status : liberado'
              :cpntTexto='linha.doc_produto.texto'
              :cpntDisabled='linha.doc_produto.disabled'
              :cpntClass='linha.doc_produto.class'
              @onClick='() => { demandaGerTabAbrirDocumentoFiscal("produto", linha) }'></App-Button>
              <!-- <div>
                <App-Button
                :cpntStatus='campos.links_docfiscal.status' 
                :cpntTexto='campos.links_docfiscal.texto'
                :cpntTipo='campos.links_docfiscal.tipo'
                :cpntIcone='campos.links_docfiscal.icone'
                :cpntClass='[ "btn", "btn-sm", "btn-primary"]'
                @onClick='() => { campos.links_docfiscal.onClick(indexL, indexCV) }'>
                  <template slot="conteudo">
                    <span v-if="[ '', null, undefined ].indexOf(linha.DocNumero) !== -1">{{ linha.p_id_doc_DocModelo }} {{ linha.p_id_doc_DocNumero }} s. {{ linha.p_id_doc_DocSerie }}</span>
                  </template>
                </App-Button>
              </div> -->
            </div>
          </template>

          <template v-slot:col_ser_doc="{ linha }">
            <!-- COLOCA O NOME DO DOCUMENTO SELECIONADO -->
            <span v-html="linha.s_doc_tp" v-if="linha.doc_servico === null"></span>

            <!-- MONTA OS BOTOES DAS NOTAS -->
            <div v-else>
              <div v-for="(nota, indexN) in linha.doc_servico" :key="'item--' + linha.id + '--' + indexN">
                <App-Button
                :cpntStatus='liberado === "" ? nota.status : liberado'
                :cpntTexto='nota.texto'
                :cpntDisabled='nota.disabled'
                :cpntClass='nota.class'
                @onClick='() => { demandaGerTabAbrirDocumentoFiscal("servico", nota) }'></App-Button>
              </div>
            </div>
          </template>

          <!-- SETA A COLUNA DE VALOR -->
          <template v-slot:col__id_checkbox="{ linha }">
            <template v-for="(item, indexB) in linha.col_check">
              <App-Button :key="'col_check--bt--' + indexB" v-if="item.tipo === 'button'"
              :cpntStatus='liberado === "" ? item.status : liberado'
              :cpntTexto='item.texto'
              :cpntIcone='item.icone'
              :cpntDisabled='item.disabled'
              :cpntClass='item.class'
              :cpntExplica='item.explica'
              @onClick='() => { item.onClick(linha) }'
              ></App-Button>

              <App-Icone :key="'col_check--icone--' + indexB" v-else-if="item.tipo === 'icone'"
              :cpntStatus='liberado === "" ? item.status : liberado'
              :cpntTipo='item.icone'
              :cpntIconeClass='item.class'
              :cpntExplica='item.explica'
              ></App-Icone>
            </template>
          </template>

          <!-- SETA PARA SELECIONAR O REGISTRO -->
          <template v-slot:col_selecionar="{ linha, indexL }">
            <App-Button @onClick='() => { cpntSelecionar(linha, indexL) }' :cpntClass="'btn btn-primary btn-sm'" :cpntIcone="'selecionar'"></App-Button>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- APRSENTA A TELA DE TOTAIS DA VENDA -->
    <App-Venda-Gerenciar-Totais  v-if="(cpntDemanda === 'venda' || cpntDemanda === 'compra') && [ '', null, undefined ].indexOf(cpntSelecionar) !== -1" :key="'totais--' + liberado" :cpntMontarFiltros="demandaGerTabMontarFiltros" :cpntMontarWhere="demandaGerTabTabelaMontarWhere" :cpntDemanda="cpntDemanda"></App-Venda-Gerenciar-Totais>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view></router-view>

    <RF-Dialog v-if="relConsolidadoPgto !== null"
    :cpntStatus='""'
    :cpntLargura='"800px"'
    :cpntOnFecharDialog='demandaGerTabGerarRelatorioConsolidado'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      Consolidado por Forma de Pagamento
    </template>

    <template slot='conteudo'>
      <App-Demanda-Relatorio-Consolidado-Pagamento
      :cpntFiltros="relConsolidadoPgto"
      ></App-Demanda-Relatorio-Consolidado-Pagamento>
    </template>
    </RF-Dialog>
  </div>
</template>


<style scoped>
</style>

<style>
  /* CONFIGURAÇOES DOS BOTÕES DA COLUNA */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col__id {
    width: 70px !important;
    min-width: 70px !important;
    max-width: 70px !important;
  }
    .dem-ger > .tabela > table > tbody > tr > td.col__id > div > span > button {
      width: 30px;
      height: 30px;
      padding: 0px;
      margin: 2px;
    }
    .dem-ger > .tabela > table > tbody > tr > td.col__id > div > span > img {
      margin: 0px 1px;
    }
    .dem-ger > .tabela > table > tbody > tr > td.col__id > div > span > svg.fa-chart-line {
      font-size: var(--font-base-soma-15);
    }

  /* CONFIGURAÇOES DA COLUNA EDITAR*/
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col_editar {
    width: 70px;
  }
    .dem-ger > .tabela > table > tbody > tr > td.col_editar > div > span > button {
      width: 34px;
      padding: 3px 0px;
    }
      .dem-ger > .tabela > table > tbody > tr > td.col_editar > div > span > button > span > img {
        width: 16px !important;
        height: auto !important;
      }

  /* CONFIGURAÇOES DA COLUNA EDITAR*/
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col_dem_ref,
  .dem-ger > .tabela > table > tbody > tr > td.col_dem_alias {
    width: 135px;
    min-width: 135px;
    max-width: 135px;
  }
  .dem-ger.dem-ger--compra > .tabela > table > tbody > tr > td.col_dem_alias,
  .dem-ger.dem-ger--venda > .tabela > table > tbody > tr > td.col_dem_alias {
    text-align: left;
  }
    .dem-ger.dem-ger--compra > .tabela > table > tbody > tr > td.col_dem_alias > div > span > button:not(.recorrencia),
    .dem-ger.dem-ger--venda > .tabela > table > tbody > tr > td.col_dem_alias > div > span > button:not(.recorrencia) {
      min-width: 80px;
    }
    .dem-ger.dem-ger--compra > .tabela > table > tbody > tr > td.col_dem_alias > div > span > button.recorrencia,
    .dem-ger.dem-ger--venda > .tabela > table > tbody > tr > td.col_dem_alias > div > span > button.recorrencia {
      margin-left: 8px;
      padding: 6px 8px;
    }
      .dem-ger.dem-ger--compra > .tabela > table > tbody > tr > td.col_dem_alias > div > span > button.recorrencia > span > img,
      .dem-ger.dem-ger--venda > .tabela > table > tbody > tr > td.col_dem_alias > div > span > button.recorrencia > span > img {
        width: 15px !important;
        height: auto !important;
      }

    .dem-ger.dem-ger--dev_fornecedor > .tabela > table > tbody > tr > td.col_dem_alias > div > span > button:disabled,
    .dem-ger.dem-ger--dev_cliente > .tabela > table > tbody > tr > td.col_dem_alias > div > span > button:disabled {
      opacity: 1 !important;
    }

  /* CONFIGURAÇOES DA COLUNA EDITAR*/
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col_pro_doc,
  .dem-ger > .tabela > table > tbody > tr > td.col_ser_doc {
    min-width: 130px;
  }
    .dem-ger > .tabela > table > tbody > tr > td.col_ser_doc > div > span > div > div {
      padding: 3px 8px;
    }
    .dem-ger > .tabela > table > tbody > tr > td.col_pro_doc > div > span > div > div > button,
    .dem-ger > .tabela > table > tbody > tr > td.col_ser_doc > div > span > div > div > button {
      width: 100%;
    }

  /* CONFIGURAÇOES DOS BOTOES DE NOTA E O DO RECIBO DE VENDA */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col_dem_chave {
    text-align: left;
    width: 150px;
    min-width: 120px;
    padding: 3px;
  }
    .dem-ger > .tabela > table > tbody > tr > td.col_dem_chave > div > span > button:not(.dem-venda-rec) {
      width: calc(100% - 40px - 8px);
    }
    .dem-ger > .tabela > table > tbody > tr > td.col_dem_chave > div > span > .dem-venda-rec {
      margin-left: 8px;
    }

  /* CONFIGURAÇOES DOS BOTÕES DE OBSERVAÇÃO */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col_valor {
    width: 80px;
    min-width: 80px;
    max-width: 100px;
    text-align: center;
  }

  /* CONFIGURAÇOES DOS BOTÕES DE OBSERVAÇÃO */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col_id_pco_item > div > span > table {
    height: 100%;
    width: 100%;
    cursor: pointer;
  }
    .dem-ger > .tabela > table > tbody > tr > td.col_id_pco_item > div > span > table > tr > td {
      padding: 10px;
    }

  /* CONFIGURAÇOES DOS BOTÕES DE OBSERVAÇÃO */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col_estoque {
    width: 50px;
    min-width: 50px;
    max-width: 50px;
    text-align: center;
  }
    .dem-ger > .tabela > table > tbody > tr > td.col_estoque  > div > span > div > span > img {
      width: 25px;
      height: auto;
    }

  .dem-ger > .tabela > table > tbody > tr > td.col_n_nf_emitidas {
    min-width: 100px;
  }
  /* CONFIGURAÇOES DOS BOTÕES DE OBSERVAÇÃO */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .dem-ger > .tabela > table > tbody > tr > td.col_obs_cli,
  .dem-ger > .tabela > table > tbody > tr > td.col_obs_emp,
  .dem-ger > .tabela > table > tbody > tr > td.col_obs_nf_pro {
    padding: 5px 0px;
  }
    .dem-ger > .tabela > table > tbody > tr > td.col_obs_cli > div > span > button,
    .dem-ger > .tabela > table > tbody > tr > td.col_obs_emp > div > span > button,
    .dem-ger > .tabela > table > tbody > tr > td.col_obs_nf_pro > div > span > button {
      padding: 4px 4px;
    }
      .dem-ger > .tabela > table > tbody > tr > td.col_obs_cli > div > span > button > span > img,
      .dem-ger > .tabela > table > tbody > tr > td.col_obs_emp > div > span > button > span > img,
      .dem-ger > .tabela > table > tbody > tr > td.col_obs_nf_pro > div > span > button > span > img {
        width: 15px;
        width: 15px !important;
        height: auto !important;
        opacity: 0.9;
      }
      
  .dem-ger > .cabecalho > .cpnt-filtros > .cpnt-filtros-coringa > .input {
    width: 428px;
  }
  .dem-ger > .cabecalho > .cpnt-filtros > .cpnt-filtros-linhas > td > table {
    width: 500px;
  }
  .dem-ger > .cabecalho > .cpnt-filtros > .cpnt-filtros-linhas > td > table > tr > .cpnt-filtros--tip,
  .dem-ger > .cabecalho > .cpnt-filtros > .cpnt-filtros-linhas > td > table > tr > .cpnt-filtros--val {
    width: 165px;
  }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    props: {
      cpntDemanda: {
        required: true,
        type: String
      },
      cpntSelecionar: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'App-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue'),
      'App-Venda-Gerenciar-Totais': () => import('@/components/demanda/Gerenciar/Demanda-Gerenciar-Totais.vue'),
      'App-Demanda-Relatorio-Consolidado-Pagamento': () => import('@/components/demanda/Relatorio/Demanda-Relatorio-Consolidado-Pagamento.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        liberado: 'carregando',
        checkbox: [],
        relConsolidadoPgto: null,
        botaoExcluir: undefined,
        botaoCopiar: undefined,
        botao: {
          status: '',
          id: 'dem-ger--novo',
          // texto: (this.cpntDemanda === 'venda' ? 'Nova Venda' : 'Nova Compra'),
          class: [ 'btn', 'btn-info' ],
          // mostrar: ((this.cpntDemanda === 'venda' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 13 ], null, false) === true) || (this.cpntDemanda === 'compra' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 19 ], null, false) === true)),
          onClick: () => {
            switch (this.cpntDemanda) {
              case 'venda':
                this.$router.push({ name: 'vendas_gerenciar_nova' })
                break
            
              case 'compra':
                this.$router.push({ name: 'compras_gerenciar_nova' })
                break

              case 'dev_cliente':
                this.$router.push({ name: 'dev_cliente_nova' })
                break

              case 'dev_fornecedor':
                this.$router.push({ name: 'dev_fornecedor_nova' })
                break
            }
          }
        },
        colunas: [],
        linha: [],
        tabper: '',
        tabPerOrder: [],
        route: '',
        field: {},
        fieldVir: [],
        where: {},
        order: {},
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        acessos: {
          veiculo: false,
          pet: false,

          NFe: false,
          NFCe: false,
          NFSe: false,
          Financeiro: false,
          GerarDocVenda: false
        },
        exportar: null
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.demandaGerTabSetarStatusGeral('carregando')

      // INICIA O CARREGAMENTO
      setTimeout(() => { this.demandaGerTabBuscarLinhas() }, 0)
    },
    methods: {
      demandaGerTabBuscarLinhas: function () {
        // CARREGA AS PERMISSOES DO USUARIO
        this.acessos.Financeiro = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, [ 9 ], null, [ 11 ], null, false) === true
        this.acessos.NFe = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20 ], null, [ 38 ], null, [ 317 ], null, false) === true

        // // VERIFICA SE PODE CRIAR VENDAS
        // if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 13 ], null, false) === true) {
        //   this.botaoCopiar = this.demandaGerTabCopiar
        // }

        // SETA O WHERE QUE DEVE REALZIAR NA API
        this.where = {}

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var removerCol = []
        var removerFieldVir = []

        // SETA A VARIAVEL QUE VAI RECEBER AS COLUNAS
        var colunas = []

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'venda':
            // SETA O WHERE QUE DEVE REALZIAR NA API
            this.where = { aAnd: [ { f: 'status', o: '<>', v: '3' } ] }

            // SETA O MAPA DE EXPORTAÇÃO
            this.exportar = {
              format: [ 'xlsx', 'pdf' ],
              search: true,
              // field: [
              //   { cod_venda:                                        'Código'            },
              //   { data_ptbr:                                        'Data Cadastro'     },
              //   { vencimento_ptbr:                                  'Data Documento'    },
              //   { p_doc_tp:                                         'Doc. Produto'      },
              //   { p_doc_n:                                          'Número NF Produto' },
              //   { s_doc_tp:                                         'Doc. Serviço'      },
              //   { virtual_s_doc_export:                             'Número NF Serviço' },

              //   { id_con_nome:                                      'Nome'              },
              //   { id_con_empresa:                                   'Nome Fantasia'     },
              //   { id_con_pessoa:                                    'Tipo Pessoa'       },

              //   { id_pet_nome:                                      'Pet Nome'          },
              //   { id_pet_id_pet_subespecie_id_especie_j_especie:    'Pet Espécie'       },
              //   { id_pet_id_pet_subespecie_j_subespecie:            'Pet Raça'          },

              //   { id_vei_placa:                                     'Veículo Placa'     },
              //   { id_vei_ref_modelo_id_marca_j_marca:               { a: 'Veículo Marca',   prioridade: 1 } },
              //   { id_vei_id_mar_nome:                               { a: 'Veículo Marca',   prioridade: 2 } },
              //   { id_vei_ref_modelo_j_modelo:                       { a: 'Veículo Modelo',  prioridade: 1 } },
              //   { id_vei_id_mod_nome:                               { a: 'Veículo Modelo',  prioridade: 2 } },
              //   { km:                                               'Veículo KM'        },

              //   { virtual_total :                                   { a: 'Líquido',         j_field: 'geral.liquido', format: "bdtoreal" } },
              //   { id_pco_item_nome:                                 'Status do processo' },
              //   { dt_ent_ptbr:                                      'Data Entrega'       },
              //   { updated_user_usuario:                             'Alterado por'       },

              //   { obs_cli:                                          'Obs. Cliente'       },
              //   { obs_emp:                                          'Obs. Empresa'       },
              //   { obs_nf_pro:                                       'Obs. NF'            },
              // ]
            }

            // VERIFICA SE TEM ACESSO AO ITEM DESEJADO
            this.acessos.pet = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true
            this.acessos.veiculo = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

            // VERIFICA AS PERMISSOES DO USUARIO
            this.acessos.NFCe = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 23 ], null, [ 46 ], null, [ 322 ], null, false) === true
            this.acessos.NFSe = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === true
            this.acessos.GerarDocVenda = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 15 ], null, false) === true

            // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
            if ([ '', null, undefined ].indexOf(this.cpntSelecionar) !== -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 107 ], null, false) === true) {
              this.botaoExcluir = this.demandaGerTabExcluir
            }

            // SETA A ROTA QUE DEVE CHAMAR
            this.route = '/venda/get'

            // SETA O NOME DA PERSONALIZAÇÃO
            this.tabper = 'Venda'

            // SETA AS ORDENAÇÕES DISPONIVEIS
            this.tabPerOrder = [
              { id: '0',  nome: 'Código Ordem Decrescente',    chave: 'cod_venda',        order: 'desc' },
              { id: '1',  nome: 'Código Ordem Crescente',      chave: 'cod_venda',        order: 'asc'  },
              { id: '2',  nome: 'Data Documento Decrescente',  chave: 'vencimento',       order: 'desc' },
              { id: '3',  nome: 'Data Documento Crescente',    chave: 'vencimento',       order: 'asc'  },
              { id: '4',  nome: 'Data de Entrega Decrescente', chave: 'dt_ent',           order: 'desc' },
              { id: '5',  nome: 'Data de Entrega Crescente',   chave: 'dt_ent',           order: 'asc'  },
              { id: '6',  nome: 'Ordem Alfabética',            chave: 'id_con_nome',      order: 'asc'  },
              { id: '7',  nome: 'Data Cadastro Decrescente',   chave: 'data',             order: 'desc' },
              { id: '8',  nome: 'Data Cadastro Crescente',     chave: 'data',             order: 'asc'  }
            ]

            // SETA OS CAMPOS VIRTUAIS QUE DEVE CHAMAR
            this.fieldVir = this.fieldVir.concat([ 's_doc', 's_doc_export', 'total', 'estoque_status' ])

            // SETA OS CAMPOS QUE DEVE CARREGAR
            this.field = {
              pdv_senha: null,
              cod_venda: null,
              status_fin: null,
              cms_status: null,
              p_doc_docs: null,
              status: null,
              id_rec: null,
              dt_ent: null,
              data: null,
              vencimento: null,
              id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } },
              id_pet: { j: { nome: null, id_pet_subespecie: { j: { j_subespecie: null, id_especie: { j: { j_especie: null } } } }, status: null } },
              id_vei: { j: { placa: null, id_mar: { j: { nome: null } }, id_mod: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } }, status: null } },
              id_pco_item: { j: { id_pco_status_item: { j: { nome: { a: 'id_pco_item_nome' }, cor: { a: 'id_pco_item_cor_fundo' }, id_pco_status: null } } } },
              p_doc_tp: null,
              p_doc_n: null,
              p_doc_s: null,
              s_doc_tp: null,
              obs_cli: null,
              obs_emp: null,
              obs_nf_pro: null,
              clu: null,
              km: null,
              updated_user: { j: { usuario: null } }
            }

            // SETA AS COLUNAS DA TABELA
            colunas = [
              { mPer: 3, chave: '_id',                                                tipo: 'checkbox', cpntValidaCheck: this.demandaGerTabValidarCheckbox },
              { mPer: 3, chave: 'editar',          nome: 'Editar',                    export: {} },
              { mPer: 1, chave: 'data_ptbr',       nome: 'Data Cadastro',             export: {} },
              { mPer: 0, chave: 'vencimento_ptbr', nome: 'Data Documento',            export: {} },
              { mPer: 2, chave: 'dem_alias',       nome: 'Código',                    export: { fields: { cod_venda: 'Código' } } },
              { mPer: 1, chave: 'pro_doc',         nome: 'Doc.Pro./Número',           export: { fields: { p_doc_tp: 'Doc. Produto', p_doc_n: 'Número NF Produto', p_doc_s: 'Série NF Produto' } } },
              { mPer: 1, chave: 'ser_doc',         nome: 'Doc.Ser./Número',           export: { fields: { s_doc_tp: 'Doc. Serviço', virtual_s_doc_export: 'Número NF Serviço' } } },
              { mPer: 2, chave: 'id_con',          nome: 'Contato',                   export: { fields: { id_con_nome: 'Nome', id_con_empresa: 'Nome Fantasia', id_con_pessoa: 'Tipo Pessoa' } } },
              { mPer: 1, chave: 'id_pet',          nome: 'Pet',                       export: { fields: { id_pet_nome: 'Pet Nome', id_pet_id_pet_subespecie_id_especie_j_especie: 'Pet Espécie', id_pet_id_pet_subespecie_j_subespecie: 'Pet Raça' } } },
              { mPer: 1, chave: 'id_vei',          nome: 'Veículo',                   export: { fields: { id_vei_placa: 'Veículo Placa', id_vei_ref_modelo_id_marca_j_marca: { a: 'Veículo Marca',   prioridade: 1 }, id_vei_id_mar_nome: { a: 'Veículo Marca',   prioridade: 2 }, id_vei_ref_modelo_j_modelo: { a: 'Veículo Modelo',  prioridade: 1 }, id_vei_id_mod_nome: { a: 'Veículo Modelo',  prioridade: 2 } } } },
              { mPer: 1, chave: 'obs_cli',         nome: 'Obs. Cliente',              export: {} },
              { mPer: 0, chave: 'obs_nf_pro',      nome: 'Obs. NF',                   export: {} },
              { mPer: 1, chave: 'obs_emp',         nome: 'Obs. Empresa',              export: {} },
              { mPer: 0, chave: 'n_nf_emitidas',   nome: 'Nº NF Emitida',             export: {} },
              { mPer: 0, chave: 'km',              nome: 'Veículo KM',                export: {} },
              { mPer: 0, chave: 'dt_ent_ptbr',     nome: 'Data Entrega',              export: {} },
              { mPer: 1, chave: 'valor',           nome: 'Valor Líquido',             export: { fields: { virtual_total: { a: 'Líquido', j_field: 'geral.liquido', format: "bdtoreal" } } } },
              { mPer: 1, chave: 'estoque',         nome: 'Estoque',                   export: { fields: { virtual_estoque_status: 'Estoque' } } },
              { mPer: 0, chave: 'id_pco_item',     nome: 'Status do processo',        export: { fields: { id_pco_item_nome: 'Status do processo' } } },
              { mPer: 1, chave: 'last',            nome: 'Última Alteração',          export: { fields: { updated_user_usuario: 'Alterado por' } } }
            ]
    
            // VERICICA SE TEM O PACOTE DE COMPRAS
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, null, null, null, null, null, null, false) === false) {
              removerCol.push('editar')
            }
    
            // VERICICA SE TEM OS PACOTES PARA CONTROLE DE ESTOQUE
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17, 6, 5 ], 'and', null, null, null, null, false) === false) {
              // SETA A COLUNA QUE DEVE REMOVER
              removerCol.push('estoque')

              // SETA A CHAVE VIRTUAL QUE DEVE REMOVER
              removerFieldVir.push('estoque_status')
            }
    
            // VERIFICA SE TEM A PERMISSÃO PARA VISUALIZAR VALORES DA VENDA
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === false) {
              // SETA A COLUNA QUE DEVE REMOVER
              removerCol.push('valor')

              // SETA A CHAVE VIRTUAL QUE DEVE REMOVER
              removerFieldVir.push('total')
            }
    
            // VERIFICA SE TEM O PACOTE SUBASE
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, null, null, null, null, false) === false) {
              removerCol.push('n_nf_emitidas')
            }
    
            // VERIFICA SE TEM O PACOTE DE VEICULO
            if (this.acessos.pet === false) {
              removerCol.push('id_pet')
            }
    
            // VERIFICA SE TEM O PACOTE DE VEICULO
            if (this.acessos.veiculo === false) {
              removerCol = removerCol.concat([ 'id_vei', 'km' ])
            }
    
            // VERIFICA SE A CONFIGURAÇÃO DE DATA DE ENTREGA ESTÁ ATIVADA
            // if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8, 28 ], 'or', null, null, null, null, false) === false || this.$store.state.configuracoes.venda.cfg_dt_ent !== true) {
            if (this.$store.state.configuracoes.venda.ven.cfg_dt_ent !== true) {
              removerCol.push('dt_ent_ptbr')
            }
    
            // VERIFICA SE TEM O PACOTE PRODUTO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, null, null, null, null, false) === false) {
              removerCol.push('pro_doc')
            }
    
            // VERIFICA SE TEM O PACOTE SERVIÇO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, null, null, null, null, false) === false) {
              // SETA A COLUNA QUE DEVE REMOVER
              removerCol.push('ser_doc')

              // SETA A CHAVE VIRTUAL QUE DEVE REMOVER
              removerFieldVir = removerFieldVir.concat([ 's_doc', 's_doc_export' ])
            }
            
            // VERIFICA SE TEM O CAMPO OBSERVAÇÃO DO CLIENTE
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 41 ], null, false) === false) {
              removerCol.push('obs_cli')
            }
            
            // VERIFICA SE TEM O CAMPO OBSERVAÇÃO DA EMPRESA
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 42 ], null, false) === false) {
              removerCol.push('obs_emp')
            }
    
            // VERIFICA SE TEM CONTROLE DE PROCESSOS
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, [ 17 ], null, null, null, false) === false) {
              removerCol.push('id_pco_item')
            }
            break

          case 'dev_cliente':
            // SETA O MAPA DE EXPORTAÇÃO
            this.exportar = {
              format: [ 'xlsx', 'pdf' ],
              search: true,
              // field: [
              //   { cod_venda:                                        'Código'            },
              //   { data_ptbr:                                        'Data Cadastro'     },
              //   { vencimento_ptbr:                                  'Data Documento'    },
              //   { p_doc_tp:                                         'Doc. Produto'      },
              //   { p_doc_n:                                          'Número NF Produto' },

              //   { id_con_nome:                                      'Nome'              },
              //   { id_con_empresa:                                   'Nome Fantasia'     },
              //   { id_con_pessoa:                                    'Tipo Pessoa'       },

              //   { virtual_total :                                   { a: 'Líquido',         j_field: 'liquido', format: "bdtoreal" } },
              //   { id_pco_item_nome:                                 'Status do processo' },
              //   { dt_ent_ptbr:                                      'Data Entrega'       },
              //   { updated_user_usuario:                             'Alterado por'       },

              //   { obs_cli:                                          'Obs. Cliente'       },
              //   { obs_emp:                                          'Obs. Empresa'       },
              //   { obs_nf_pro:                                       'Obs. NF'            },
              // ]
            }

            // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 17 ], null, [ 59 ], null, [ 905 ], null, false) === true) {
              this.botaoExcluir = this.demandaGerTabExcluir
            }

            // SETA O WHERE QUE DEVE REALZIAR NA API
            this.where = { aAnd: [ { f: 'status', o: '<>', v: '3' } ] }

            // SETA A ROTA QUE DEVE CHAMAR
            this.route = '/demanda/dem-dev-cliente/get'

            // SETA O NOME DA PERSONALIZAÇÃO
            this.tabper = 'DemDevCliente'

            // SETA AS ORDENAÇÕES DISPONIVEIS
            this.tabPerOrder = [
              { id: '0',  nome: 'Código Ordem Decrescente',    chave: 'dem_dev_cliente',  order: 'desc' },
              { id: '1',  nome: 'Código Ordem Crescente',      chave: 'dem_dev_cliente',  order: 'asc'  },
              { id: '2',  nome: 'Data Documento Decrescente',  chave: 'vencimento',       order: 'desc' },
              { id: '3',  nome: 'Data Documento Crescente',    chave: 'vencimento',       order: 'asc'  },
              // { id: '4',  nome: 'Data de Entrega Decrescente', chave: 'dt_ent',           order: 'desc' },
              // { id: '5',  nome: 'Data de Entrega Crescente',   chave: 'dt_ent',           order: 'asc'  },
              { id: '6',  nome: 'Ordem Alfabética',            chave: 'id_con_nome',      order: 'asc'  },
              { id: '7',  nome: 'Data Cadastro Decrescente',   chave: 'data',             order: 'desc' },
              { id: '8',  nome: 'Data Cadastro Crescente',     chave: 'data',             order: 'asc'  }
            ]

            // SETA OS CAMPOS VIRTUAIS QUE DEVE CHAMAR
            this.fieldVir = []
            this.fieldVir = this.fieldVir.concat([ 'total', 'estoque_status' ])

            // SETA OS CAMPOS QUE DEVE CARREGAR
            this.field = {
              dem_ref: null,
              dem_dev_cliente: null,
              p_doc_docs: null,
              status: null,
              data: null,
              vencimento: null,
              id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } },
              p_doc_tp: null,
              p_doc_n: null,
              p_doc_s: null,
              obs: { a: 'obs_nf_pro' },
              obs_emp: null,
              // obs_nf_pro: null,
              updated_user: { j: { usuario: null } }
            }

            // SETA AS COLUNAS DA TABELA
            colunas = [
              { mPer: 3, chave: '_id',                                                tipo: 'checkbox', cpntValidaCheck: this.demandaGerTabValidarCheckbox },
              { mPer: 3, chave: 'editar',          nome: 'Editar',                    export: {} },
              { mPer: 1, chave: 'data_ptbr',       nome: 'Data Cadastro',             export: {} },
              { mPer: 2, chave: 'dem_alias',       nome: 'Código',                    export: { fields: { dem_dev_cliente: 'Código' } } },
              { mPer: 1, chave: 'pro_doc',         nome: 'Doc.Pro./Número',           export: { fields: { p_doc_tp: 'Doc. Produto', p_doc_n: 'Número NF Produto', p_doc_s: 'Série NF Produto' } } },
              { mPer: 2, chave: 'id_con',          nome: 'Contato',                   export: { fields: { id_con_nome: 'Nome', id_con_empresa: 'Nome Fantasia', id_con_pessoa: 'Tipo Pessoa' } } },
              // { mPer: 1, chave: 'obs_cli',         nome: 'Obs. Cliente',              export: {} },
              { mPer: 0, chave: 'obs_nf_pro',      nome: 'Obs. NF',                   export: {} },
              { mPer: 1, chave: 'obs_emp',         nome: 'Obs. Empresa',              export: {} },
              { mPer: 1, chave: 'valor',           nome: 'Valor Líquido',             export: { fields: { virtual_total: { a: 'Líquido', j_field: 'liquido', format: "bdtoreal" } } } },
              { mPer: 1, chave: 'estoque',         nome: 'Estoque',                   export: { fields: { virtual_estoque_status: 'Estoque' } } },
              { mPer: 1, chave: 'last',            nome: 'Última Alteração',          export: { fields: { updated_user_usuario: 'Alterado por' } } }
            ]
            break

          case 'dev_fornecedor':
            // SETA O MAPA DE EXPORTAÇÃO
            this.exportar = {
              format: [ 'xlsx', 'pdf' ],
              search: true,
              // field: [
              //   { cod_venda:                                        'Código'            },
              //   { data_ptbr:                                        'Data Cadastro'     },
              //   { vencimento_ptbr:                                  'Data Documento'    },
              //   { p_doc_tp:                                         'Doc. Produto'      },
              //   { p_doc_n:                                          'Número NF Produto' },

              //   { id_con_nome:                                      'Nome'              },
              //   { id_con_empresa:                                   'Nome Fantasia'     },
              //   { id_con_pessoa:                                    'Tipo Pessoa'       },

              //   { virtual_total :                                   { a: 'Líquido',         j_field: 'liquido', format: "bdtoreal" } },
              //   { id_pco_item_nome:                                 'Status do processo' },
              //   { dt_ent_ptbr:                                      'Data Entrega'       },
              //   { updated_user_usuario:                             'Alterado por'       },

              //   { obs_cli:                                          'Obs. Cliente'       },
              //   { obs_emp:                                          'Obs. Empresa'       },
              //   { obs_nf_pro:                                       'Obs. NF'            },
              // ]
            }

            // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 17 ], null, [ 59 ], null, [ 905 ], null, false) === true) {
              this.botaoExcluir = this.demandaGerTabExcluir
            }

            // SETA O WHERE QUE DEVE REALZIAR NA API
            this.where = { aAnd: [ { f: 'status', o: '<>', v: '3' } ] }

            // SETA A ROTA QUE DEVE CHAMAR
            this.route = '/demanda/dem-dev-fornecedor/get'

            // SETA O NOME DA PERSONALIZAÇÃO
            this.tabper = 'DemDevFornecedor'

            // SETA AS ORDENAÇÕES DISPONIVEIS
            this.tabPerOrder = [
              { id: '0',  nome: 'Código Ordem Decrescente',    chave: 'dem_dev_fornecedor',  order: 'desc' },
              { id: '1',  nome: 'Código Ordem Crescente',      chave: 'dem_dev_fornecedor',  order: 'asc'  },
              { id: '2',  nome: 'Data Documento Decrescente',  chave: 'vencimento',       order: 'desc' },
              { id: '3',  nome: 'Data Documento Crescente',    chave: 'vencimento',       order: 'asc'  },
              // { id: '4',  nome: 'Data de Entrega Decrescente', chave: 'dt_ent',           order: 'desc' },
              // { id: '5',  nome: 'Data de Entrega Crescente',   chave: 'dt_ent',           order: 'asc'  },
              { id: '6',  nome: 'Ordem Alfabética',            chave: 'id_con_nome',      order: 'asc'  },
              { id: '7',  nome: 'Data Cadastro Decrescente',   chave: 'data',             order: 'desc' },
              { id: '8',  nome: 'Data Cadastro Crescente',     chave: 'data',             order: 'asc'  }
            ]

            // SETA OS CAMPOS VIRTUAIS QUE DEVE CHAMAR
            this.fieldVir = []
            this.fieldVir = this.fieldVir.concat([ 'total', 'estoque_status' ])

            // SETA OS CAMPOS QUE DEVE CARREGAR
            this.field = {
              dem_ref: null,
              dem_dev_fornecedor: null,
              p_doc_docs: null,
              status: null,
              data: null,
              vencimento: null,
              id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } },
              p_doc_tp: null,
              p_doc_n: null,
              p_doc_s: null,
              obs: { a: 'obs_nf_pro' },
              obs_emp: null,
              // obs_nf_pro: null,
              updated_user: { j: { usuario: null } }
            }

            // SETA AS COLUNAS DA TABELA
            colunas = [
              { mPer: 3, chave: '_id',                                                tipo: 'checkbox', cpntValidaCheck: this.demandaGerTabValidarCheckbox },
              { mPer: 3, chave: 'editar',          nome: 'Editar',                    export: {} },
              { mPer: 1, chave: 'data_ptbr',       nome: 'Data Cadastro',             export: {} },
              { mPer: 2, chave: 'dem_alias',       nome: 'Código',                    export: { fields: { dem_dev_cliente: 'Código' } } },
              { mPer: 1, chave: 'pro_doc',         nome: 'Doc.Pro./Número',           export: { fields: { p_doc_tp: 'Doc. Produto', p_doc_n: 'Número NF Produto', p_doc_s: 'Série NF Produto' } } },
              { mPer: 2, chave: 'id_con',          nome: 'Contato',                   export: { fields: { id_con_nome: 'Nome', id_con_empresa: 'Nome Fantasia', id_con_pessoa: 'Tipo Pessoa' } } },
              // { mPer: 1, chave: 'obs_cli',         nome: 'Obs. Fornecedor',           export: {} },
              { mPer: 0, chave: 'obs_nf_pro',      nome: 'Obs. NF',                   export: {} },
              { mPer: 1, chave: 'obs_emp',         nome: 'Obs. Empresa',              export: {} },
              { mPer: 1, chave: 'valor',           nome: 'Valor Líquido',             export: { fields: { virtual_total: { a: 'Líquido', j_field: 'liquido', format: "bdtoreal" } } } },
              { mPer: 1, chave: 'estoque',         nome: 'Estoque',                   export: { fields: { virtual_estoque_status: 'Estoque' } } },
              { mPer: 1, chave: 'last',            nome: 'Última Alteração',          export: { fields: { updated_user_usuario: 'Alterado por' } } }
            ]
            break
        
          case 'compra':
            // SETA O MAPA DE EXPORTAÇÃO
            this.exportar = {
              format: [ 'xlsx', 'pdf' ],
              search: true,
              // field: [
              //   { dem_compra:                                       'Código'           },
              //   { data_ptbr:                                        'Data Cadastro'     },
              //   { vencimento_ptbr:                                  'Data Documento'    },
              //   { p_doc_tp:                                         'Doc. Produto'      },
              //   { p_doc_n:                                          'Número NF Produto' },

              //   { id_con_nome:                                      'Nome'              },
              //   { id_con_empresa:                                   'Nome Fantasia'     },
              //   { id_con_pessoa:                                    'Tipo Pessoa'       },

              //   { virtual_total :                                   { a: 'Líquido',      j_field: 'liquido', format: "bdtoreal" } },
              //   { updated_user_usuario:                             'Alterado por'       },

              //   { obs_cli:                                          'Obs. Fornecedor'    },
              //   { obs_emp:                                          'Obs. Empresa'       },
              //   { obs_nf_pro:                                       'Obs. NF'            },
              // ]
            }

            // SETA O WHERE QUE DEVE REALZIAR NA API
            this.where = { aAnd: [ { f: 'dem_status', o: '<>', v: '3' } ] }

            // SETA A ROTA QUE DEVE CHAMAR
            this.route = '/demanda/dem-compra/get'

            // SETA O NOME DA PERSONALIZAÇÃO
            this.tabper = 'DemCompra'

            // SETA AS ORDENAÇÕES DISPONIVEIS
            this.tabPerOrder = [
              { id: '0',  nome: 'Código Ordem Decrescente',    chave: 'dem_compra',       order: 'desc' },
              { id: '1',  nome: 'Código Ordem Crescente',      chave: 'dem_compra',       order: 'asc'  },
              { id: '2',  nome: 'Data Documento Decrescente',  chave: 'vencimento',       order: 'desc' },
              { id: '3',  nome: 'Data Documento Crescente',    chave: 'vencimento',       order: 'asc'  },
              // { id: '4',  nome: 'Data de Entrega Decrescente', chave: 'dt_ent',           order: 'desc' },
              // { id: '5',  nome: 'Data de Entrega Crescente',   chave: 'dt_ent',           order: 'asc'  },
              { id: '6',  nome: 'Ordem Alfabética',            chave: 'id_con_nome',      order: 'asc'  },
              { id: '7',  nome: 'Data Cadastro Decrescente',   chave: 'data',             order: 'desc' },
              { id: '8',  nome: 'Data Cadastro Crescente',     chave: 'data',             order: 'asc'  }
            ]

            // SETA OS CAMPOS VIRTUAIS QUE DEVE CHAMAR
            // this.fieldVir = this.fieldVir.concat([ 's_doc', 's_doc_export', 'total', 'estoque_status' ])
            this.fieldVir = this.fieldVir.concat([ 'total', 'estoque_status' ])

            // SETA OS CAMPOS QUE DEVE CARREGAR
            this.field = {
              dem_compra: null,
              status_fin: null,
              p_doc_docs: null,
              dem_status: { a: 'status' },
              id_rec: null,
              dt_ent: null,
              data: null,
              vencimento: null,
              id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } },
              p_doc_tp: null,
              p_doc_n: null,
              p_doc_s: null,
              dem_obs: { a: 'obs_cli' },
              dem_obs_emp: { a: 'obs_emp' },
              dem_obs_nf: { a: 'obs_nf_pro' },
              dem_obs_nf_separado: { a: 'obs_nf_pro_separado' },
              updated_user: { j: { usuario: null } }
            }

            // SETA AS COLUNAS DA TABELA
            colunas = [
              { mPer: 3, chave: '_id',                                                tipo: 'checkbox', cpntValidaCheck: this.demandaGerTabValidarCheckbox },
              { mPer: 3, chave: 'editar',          nome: 'Editar',                    export: {} },
              { mPer: 1, chave: 'data_ptbr',       nome: 'Data Cadastro',             export: {} },
              { mPer: 0, chave: 'vencimento_ptbr', nome: 'Data Documento',            export: {} },
              { mPer: 2, chave: 'dem_alias',       nome: 'Código',                    export: { fields: { dem_compra: 'Código' } } },
              { mPer: 1, chave: 'pro_doc',         nome: 'Doc.Pro./Número',           export: { fields: { p_doc_tp: 'Doc. Produto', p_doc_n: 'Número NF Produto', p_doc_s: 'Série NF Produto' } } },
              { mPer: 2, chave: 'id_con',          nome: 'Contato',                   export: { fields: { id_con_nome: 'Nome', id_con_empresa: 'Nome Fantasia', id_con_pessoa: 'Tipo Pessoa' } } },
              { mPer: 1, chave: 'obs_cli',         nome: 'Obs. Fornecedor',           export: {} },
              { mPer: 0, chave: 'obs_nf_pro',      nome: 'Obs. NF',                   export: {} },
              { mPer: 1, chave: 'obs_emp',         nome: 'Obs. Empresa',              export: {} },
              { mPer: 1, chave: 'valor',           nome: 'Valor Líquido',             export: { fields: { virtual_total: { a: 'Líquido', j_field: 'liquido', format: "bdtoreal" } } } },
              { mPer: 1, chave: 'estoque',         nome: 'Estoque',                   export: { fields: { virtual_estoque_status: 'Estoque' } } },
              { mPer: 1, chave: 'last',            nome: 'Última Alteração',          export: { fields: { updated_user_usuario: 'Alterado por' } } }
            ]
            
            // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
            if ([ '', null, undefined ].indexOf(this.cpntSelecionar) !== -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 108 ], null, false) === true) {
              this.botaoExcluir = this.demandaGerTabExcluir
            }

            // REMOVE A COLUNA EDITAR
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 47 ], null, false) === false) {
              removerCol.push('obs_cli')
            }

            // REMOVE A COLUNA EDITAR
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 46 ], null, false) === false) {
              removerCol.push('obs_cli')
            }
            break
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if ([ '', null, undefined ].indexOf(this.cpntSelecionar) === -1) {
          // REMOVE O BOTÃO DE EXPORTAÇÃO
          this.exportar = null

          // ADICIONA O VALOR QUE NÃO DEVE COLOCAR ORDENAÇÃO MPER
          this.estruturaQueryGet[0].push('sem_order_mper')

          // LIMPA A ORDENAÇÃO
          this.order = {}

          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var indexD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // SETA A ORDENAÇÃO DA TELA
          this.order[indexD] = 'desc'

          // REMOVE AS COLUNAS QUE NÃO PODEM SER COPAIDAS
          removerCol = removerCol.concat([ '_id', 'editar' ])

          // CRIA UMA NOVA COLUNA PARA SELECIONAR
          colunas.unshift({ mPer: 3, chave: 'selecionar', nome: 'Selecionar' })
        }

        // REMOVE A COLUNA EDITAR
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, null, null, null, null, null, null, false) === false) {
          removerCol.push('selecionar')
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (removerCol.length >= 1) {
          colunas = colunas.filter(item => removerCol.indexOf(item.chave) === -1)
        }

        // REMOVE OS CAMPOS VIRTUAIS NÃO UTILIZADOS
        if (removerFieldVir.length >= 1) {
          this.fieldVir = this.fieldVir.filter(item => removerFieldVir.indexOf(item) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
          this.demandaGerTabReiniciar()
        } else {
          this.demandaGerTabSetarStatusGeral('')
        }
      },
      demandaGerTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}
        
        // CONVERTE O VALOR RECEBIDO
        switch (where.o){

          case '%':

            where.o = 'like'
            break

          case '%64':
            
            where.o = 'likeFromB64'
            break

        }

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var demandaFieldRef = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'codigo':
            retorno.where = { f: demandaFieldRef, o: 'in', v: where.v }
            break

          case 'status':
            if (this.cpntDemanda === 'compra') {
              retorno.where = { f: 'dem_status', o: '=', v: (where.v === 'demanda' ? '2' : '1') }
            } else {
              retorno.where = { f: 'status', o: '=', v: (where.v === 'demanda' ? '2' : '1') }
            }
            break

          case 'last_at':
            // VERIFICA SE TEM QUE GERAR O VALOR
            if ([ '', null, undefined ].indexOf(where.v._dataIni) !== -1) {
              where.v._dataIni = moment(where.v.dataIni, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            if ([ '', null, undefined ].indexOf(where.v._dataFim) !== -1) {
              where.v._dataFim = moment(where.v.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }

            // SETA O WHERE QUE DEVE REALIZAR
            if (where.o === '=') {
              retorno.where = { aAnd: [
                { f: 'vencimento', o: '>=', v: where.v._dataIni + ' 00:00:00' },
                { f: 'vencimento', o: '<=', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if (where.o === '<>') {
              retorno.where = { aOr: [
                { f: 'vencimento', o: '<', v: where.v._dataIni + ' 00:00:00' },
                { f: 'vencimento', o: '>', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '<=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { f: 'vencimento', o: where.o, v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '>=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { f: 'vencimento', o: '>', v: where.v._dataIni + ' 00:00:00' }
              ] }
            }
            break

          case 'last_user':
            retorno.where = { f: 'updated_user', o: where.o, v: where.v.join(',') }
            break

          case 'financeiro':
            retorno.where = { f: 'status_fin', o: where.o, v: (where.v === 's' ? '1' : '0') }
            break

          case 'id_con_nome':
            if (where.o === '=') {
              retorno.where = { f: 'id_con', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { m: 'contato', f: 'nome' })
            }
            break

          case 'id_con_cnpj':
          case 'id_con_cpf':
            retorno.where = { m: 'contato', f: 'cnpj_cpf', o: where.o, v: where.v }
            break

          case 'id_con_telefone':
            retorno.where = { aOr: [
              { m: 'contato', f: 'tel_res', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_com', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_cel', o: where.o, v: where.v }
            ] }
            break

          case 'id_con_email':
            retorno.where = { m: 'contato', f: 'email', o: where.o, v: where.v }
            break

          case 'id_con_estado':
            retorno.where = { m: 'contato', f: 'id_estado', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_cidade':
            retorno.where = { m: 'contato', f: 'id_cidade', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_tp_con':
            retorno.where = { m: 'contato', f: 'id_tp_con', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_pessoa':
            retorno.where = { m: 'contato', f: 'pessoa', o: where.o, v: where.v }
            break

          case 'id_pet_nome':
            if (where.o === '=') {
              retorno.where = { f: 'id_pet', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { m: 'pet', f: 'nome' })
            }
            break

          case 'id_pet_sexo':
            retorno.where = { m: 'pet', f: 'sexo', o: where.o, v: (where.v === 'n' ? '' : where.v) }
            break

          case 'id_pet_especie':
            retorno.where = { m: 'pet', f: 'id_pet_subespecie', o: 'in', r: 'id', q: {
              model: 'pet_subespecie',
              where: { f: 'id_especie', o: '=', v: where.v.join() }
            } }
            break

          case 'id_pet_raca':
            retorno.where = { m: 'pet', f: 'id_pet_subespecie', o: where.o, v: where.v }
            break

          case 'id_vei_placa':
            if (where.o === '=') {
              retorno.where = { f: 'id_vei', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { m: 'veiculo', f: 'placa' })
            }
            break

          case 'id_vei_modelo':
            if (this.$store.state.flagBuscaVei === true) {
              retorno.where = { m: 'veiculo', f: 'ref_modelo', o: 'in', v: where.v.join() }
            } else {
              retorno.where = { m: 'veiculo', f: 'id_mod', o: 'in', v: where.v.join() }
            }
            break

          case 'id_vei_marca':
            if (this.$store.state.flagBuscaVei === true) {
              retorno.where = { m: 'veiculo', f: 'ref_modelo', o: 'in', r: 'id', q: {
                model: 'vei_modelo',
                where: { f: 'id_marca', o: '=', v: where.v.join() }
              } }
            } else {
              retorno.where = { m: 'veiculo', f: 'id_mar', o: 'in', v: where.v.join() }
            }
            break

          case 'pco':
            if (where.o === '=') {
              retorno.where = { f: demandaFieldRef, o: 'in', r: demandaFieldRef, q: {
                model: 'pco_item',
                where: { aAnd: [
                  { f: 'id_pco_status_item', o: 'in', v: where.v.join(',') },
                  { f: 'selecionado', o: '=', v: '1' }
                ] }
              } }
            } else {
              retorno.where = { f: demandaFieldRef, o: 'in', r: demandaFieldRef, q: {
                model: 'pco_item',
                where: { aAnd: [
                  { f: 'id_pco_status_item', o: 'notIn', v: where.v.join(',') },
                  { f: 'selecionado', o: '=', v: '1' }
                ] }
              } }
            }
            break

          case 'NFeFornecedor':
            if (where.o === '=') {
              retorno.where = { aAnd: [
                { f: 'p_doc_tp', o: (where.v === 's' ? '=' : '<>' ), v: 'NFeFornecedor' }
              ] }
            } else {
              retorno.where = { aAnd: [ { f: 'p_doc_n', o: '=', v: where.v } ] }
            }
            break

          case 'NFCeFornecedor':
            if (where.o === '=') {
              retorno.where = { aAnd: [
                { f: 'p_doc_tp', o: (where.v === 's' ? '=' : '<>' ), v: 'NFCeFornecedor' }
              ] }
            } else {
              retorno.where = { aAnd: [ { f: 'p_doc_n', o: '=', v: where.v } ] }
            }
            break

          case 'NFe':
          case 'NFCe':
            if (where.o === 'ope') {
              retorno.where = { aAnd: [
                { f: 'p_doc_docs', o: 'isNotNull' },
                { f: 'p_doc_docs', o: '<>', v: '0' },
                { f: 'p_doc_ope', o: '=', v: where.v },
              ] }
            } else if (where.v === 'N' || where.v.indexOf('N') !== -1) {
              retorno.where = { f: 'p_doc_docs', o: '=', v: '0' }
            } else if (where.o === 'sit') {
              retorno.where = { aAnd: [ { f: 'p_doc_docs', o: 'in', r: 'id', q: {
                model: 'doc_fiscal',
                where: { aAnd: [
                  { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: where.f },
                  { m: 'doc_fiscal', f: 'SitCodigo', o: 'in', v: where.v.join(',') }
                ] }
              } } ] }
            } else {
              retorno.where = { aAnd: [ { f: 'p_doc_docs', o: 'in', r: 'id', q: {
                model: 'doc_fiscal',
                where: { aAnd: [
                  { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: where.f },
                  { m: 'doc_fiscal', f: 'DocNumero', o: 'in', v: where.v }
                ] }
              } } ] }
            }

            // SETA O TIPO DE DOCUMENTO
            retorno.where = { aAnd: [ { f: 'p_doc_tp', o: '=', v: where.f }, retorno.where ] }
            break

          case 'NFSe':
            if (where.o === 'sit' && (where.v === 'N' || where.v.indexOf('N') !== -1)) {
              retorno.where = { f: demandaFieldRef, o: 'in', r: demandaFieldRef, q: {
                model: 'ven_pre_nfse',
                where: { f: 's_doc_docs', o: '=', v: '0' }
              } }

              //   where: { aAnd: [ { f: 's_doc_docs', o: 'in', r: 'id', q: {
              //     model: 'doc_fiscal',
              //     where: { aAnd: [
              //       { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: where.f },
              //       { m: 'doc_fiscal', f: 'SitCodigo', o: 'in', v: where.v.join(',') }
              //     ] }
              //   } } ] }
              // } }
            } else if (where.o === 'sit') {
              retorno.where = { f: demandaFieldRef, o: 'in', r: demandaFieldRef, q: {
                model: 'ven_pre_nfse',
                where: { aAnd: [ { f: 's_doc_docs', o: 'in', r: 'id', q: {
                  model: 'doc_fiscal',
                  where: { aAnd: [
                    { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: where.f },
                    { m: 'doc_fiscal', f: 'SitCodigo', o: 'in', v: where.v.join(',') }
                  ] }
                } } ] }
              } }
            } else {
              retorno.where = { f: demandaFieldRef, o: 'in', r: demandaFieldRef, q: {
                model: 'ven_pre_nfse',
                where: { aAnd: [ { f: 's_doc_docs', o: 'in', r: 'id', q: {
                  model: 'doc_fiscal',
                  where: { aAnd: [
                    { m: 'doc_fiscal', f: 'DocModelo', o: '=', v: where.f },
                    { aOr: [
                      { aAnd: [
                        { m: 'doc_fiscal', f: 'DocNumero', o: 'in', v: where.v },
                        { aOr: [
                          { m: 'doc_fiscal', f: 'DocAliasNum', o: 'isNull' },
                          { m: 'doc_fiscal', f: 'DocAliasNum', o: '=', v: '' },
                          { m: 'doc_fiscal', f: 'DocAliasNum', o: '=', v: '0' }
                        ] }
                      ] },
                      { m: 'doc_fiscal', f: 'DocAliasNum', o: 'in', v: where.v }
                    ] }
                  ] }
                } } ] }
              } }
            }

            // SETA O TIPO DE DOCUMENTO
            retorno.where = { aAnd: [ { f: 's_doc_tp', o: '=', v: where.f }, retorno.where ] }
            break

          case 'busca':
            if (isNaN(where.v) === false) {
              retorno.where = { o: 's.ft', v: where.v }
            } else {
              // SETA OS DADOS QUE SERÁ BUSCADO NO MODEL DE VENDA
              retorno.where = { aOr: [ { o: 's.ft', v: where.v } ] }
  
              // SETA A INFORMAÇÃO DE BUSCA
              if (this.acessos.veiculo === true) {
                retorno.where.aOr.push({ m: 'veiculo',    o: 's.ft', v: where.v })
                retorno.where.aOr.push({ m: 'vei_mod',    o: 's.ft', v: where.v })
                retorno.where.aOr.push({ m: 'vei_mar',    o: 's.ft', v: where.v })
                retorno.where.aOr.push({ m: 'vei_marca',  o: 's.ft', v: where.v })
                retorno.where.aOr.push({ m: 'vei_modelo', o: 's.ft', v: where.v })
              }
  
              // SETA A INFORMAÇÃO DE BUSCA
              if (this.acessos.pet === true) {
                retorno.where.aOr.push({ m: 'pet', o: 's.ft', v: where.v })
              }
  
              // ADICIONA A BUSCA DE CONTATO
              retorno.where.aOr.push({ m: 'contato', o: 's.ft', v: where.v })
            }
            break

          case 'alias':
            if (where.v === '0') {
              retorno.where = { f: 'id_alias', o: 'isNull' }
            } else {
              retorno.where = { f: 'id_alias', o: '=', v: where.v }
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      demandaGerTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demandaGerTabSetarStatusLiberado: function (status) {
        // SETA O STATUS DA TELA
        this.liberado = (status === '' || status === true) ? '' : (status === false ? 'carregando' : status)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demandaGerTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.demandaGerTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      demandaGerTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.demandaGerTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      demandaGerTabMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.demandaGerTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      demandaGerTabSetarLinhas: function (vetor) {
        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_VERIFICA_COR_LETRA = require('@/assets/js/Funcoes-Gerais.js').FUN_VERIFICA_COR_LETRA

        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          // SETA O NUMERO DO REGISTRO
          vetor[index].dem_alias = vetor[index][chaveD]

          // SETA A INFORMAÇÃO PARA UTILIZAR NO CHECKBOX
          vetor[index]._id = vetor[index].dem_alias

          // VERIFICA SE TEM QUE CONVERTER O VALOR
          if ([ 'compra', 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1) {
            vetor[index].virtual_total = { produto: vetor[index].virtual_total, geral: vetor[index].virtual_total }
          }

          // SETA O BOTÃO EDITAR
          vetor[index].vend_editar = {
            status: '',
            tipo: 'icone',
            icone: 'editar',
            texto: '',
            class: [ 'btn', 'btn-warning', 'btn-sm' ],
            mostrar: true,
            onClick: this.demandaGerTabEditarVenda
          }

          // SETA O BOTÃO DO DOCUMENTO
          vetor[index].demanda_doc = {
            status: '',
            texto: this.demandaGerTabMontarBotaoDemandaDocTexto(vetor[index]),
            class: this.demandaGerTabMontarBotaoDemandaDocClasse(vetor[index]),
            mostrar: true,
            disabled: [ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1,
            onClick: (demandaId) => { this.demandaGerTabReciboDocumento(demandaId, this.cpntDemanda) }
          }

          // VERIFICA SE DEVE CRIAR O BOTÃO ADICIONAL
          if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1) {
            vetor[index].demanda_ref_doc = {
              status: '',
              texto: this.demandaGerTabMontarBotaoDemandaDocTexto(vetor[index], 'dem_ref'),
              class: [ 'btn', 'btn-sm', 'btn-default' ],
              mostrar: true,
              onClick: (demandaId) => { this.demandaGerTabReciboDocumento(demandaId, ([ 'dev_cliente' ].indexOf(this.cpntDemanda) !== -1 ? 'venda' : 'compra')) }
            }
          }

          // SETA O BOTÃO DA RECORRENCIA
          vetor[index].demanda_rec = null
          if ([ '', null, undefined, '0' ].indexOf(vetor[index].id_rec) === -1) {
            vetor[index].demanda_rec = {
              status: '',
              icone: 'relogio',
              texto: '',
              class: [ 'btn', 'btn-default' ],
              mostrar: true,
              onClick: this.demandaGerTabAbrirRecorrencia
            }
          }
          
          // SETA O BOTÃO PARA OS DADOS DA VENDA
          vetor[index].link_cadastro_con = {
            status: '',
            class: [ 'btn', 'btn-default', 'bt-link-cadastro' ],
            mostrar: true,
            onClick: this.demandaGerTabAbrirCadastro
          }

          // SETA O BOTÃO PARA OS DADOS DA VENDA
          vetor[index].link_cadastro_pet = null
          if ([ '', null, undefined, '0', 0 ].indexOf(vetor[index].id_pet) === -1) {
            vetor[index].link_cadastro_pet = {
              status: '',
              class: [ 'btn', 'btn-default', 'bt-link-cadastro' ],
              mostrar: true,
              onClick: this.demandaGerTabAbrirCadastro
            }
          }

          // SETA O BOTÃO PARA OS DADOS DA VENDA
          vetor[index].link_cadastro_vei = null
          if ([ '', null, undefined, '0', 0 ].indexOf(vetor[index].id_vei) === -1) {
            vetor[index].link_cadastro_vei = {
              status: '',
              class: [ 'btn', 'btn-default', 'bt-link-cadastro' ],
              mostrar: true,
              onClick: this.demandaGerTabAbrirCadastro
            }
          }

          // VERIFICA SE DEVE INCLUIR O BOTÃO OBS CLI
          vetor[index].obs_cli_bt = null
          if ([ '', null, undefined ].indexOf(vetor[index].obs_cli) === -1) {
            vetor[index].obs_cli_bt = {
              status: '',
              icone: 'mais',
              class: [ 'btn', 'btn-default' ],
              mostrar: true,
              onClick: (indexL) => { this.linha[indexL].obs_cli_bt = null }
            }
          }

          // VERIFICA SE DEVE INCLUIR O BOTÃO OBS EMP
          vetor[index].obs_emp_bt = null
          if ([ '', null, undefined ].indexOf(vetor[index].obs_emp) === -1) {
            vetor[index].obs_emp_bt = {
              status: '',
              icone: 'mais',
              class: [ 'btn', 'btn-default' ],
              mostrar: true,
              onClick: (indexL) => { this.linha[indexL].obs_emp_bt = null }
            }
          }

          // VERIFICA SE DEVE INCLUIR O BOTÃO OBS NF
          vetor[index].obs_nf_pro_bt = null
          if ([ '', null, undefined ].indexOf(vetor[index].obs_nf_pro) === -1) {
            vetor[index].obs_nf_pro_bt = {
              status: '',
              icone: 'mais',
              class: [ 'btn', 'btn-default' ],
              mostrar: true,
              onClick: (indexL) => { this.linha[indexL].obs_nf_pro_bt = null }
            }
          }

          // VERIFICA SE DEVE ICONE DE ESTOQUE
          vetor[index].estoque = null
          if ([ '', null, undefined, 'OK' ].indexOf(vetor[index].virtual_estoque_status) === -1) {
            vetor[index].estoque = { status: '', icone: 'erro-vermelho', explica: { mensagem: vetor[index].virtual_estoque_status.join('<br/><br/>'), posicaoMy: "top right", posicaoAt: "bottom left" } }
          } else if (vetor[index].virtual_estoque_status === 'OK') {
            vetor[index].estoque = { status: '', icone: 'check-verde' }
          }
          
          // MONTA O VALOR DO CAMPO
          vetor[index].valor = this.demandaGerTabFormatarValor(vetor[index])

          // VERIFICA SE DEVE COLOCAR BOTÃO DE NF PRODUTO
          vetor[index].doc_produto = null
          if (this.demandaGerTabValidarItemTemNotaProduto(vetor[index]) === true && [ '', null, undefined ].indexOf(vetor[index].p_doc_n) === -1) {
            // INICIA O CAMPO
            vetor[index].doc_produto = { status: '', disabled: false }

            // SETA O TEXTO DO BOTÃO
            vetor[index].doc_produto.texto = vetor[index].p_doc_tp + ' ' + vetor[index].p_doc_n + ' s.' + vetor[index].p_doc_s

            // SETA AS CLASSES DO BOTÃO
            vetor[index].doc_produto.class = 'btn btn-sm btn-primary'
          } else if ([ 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(vetor[index].p_doc_tp) !== -1) {
            // INICIA O CAMPO
            vetor[index].doc_produto = { status: '', disabled: false }

            // SETA O TEXTO DO BOTÃO
            vetor[index].doc_produto.texto = (vetor[index].p_doc_tp === 'NFeFornecedor' ? 'NFe' : 'NFCe') + ' ' + vetor[index].p_doc_n + ' s.' + vetor[index].p_doc_s

            // SETA AS CLASSES DO BOTÃO
            vetor[index].doc_produto.class = 'btn btn-sm btn-warning'
          }

          // VERIFICA SE DEVE COLOCAR BOTÃO DE NF SERVIÇO
          vetor[index].doc_servico = null
          if (this.demandaGerTabValidarItemTemNotaServico(vetor[index]) === true) {
            // INICIA O VETOR
            vetor[index].doc_servico = []

            // RODA O VETOR EM TODOS AS NOTAS
            for (var indexN in vetor[index].virtual_s_doc) {
              if ([ '', null, undefined, '0', 0 ].indexOf(vetor[index].virtual_s_doc[indexN].s_doc_docs) === -1) {
                // SETA O BOTÃO NFS
                var botaoNFS = { status: '', disabled: false, s_doc_docs: vetor[index].virtual_s_doc[indexN].s_doc_docs }
  
                // VERIFICVA SE É UM RPS OU NFSE
                if ([ '', null, undefined, '0' ].indexOf(vetor[index].virtual_s_doc[indexN].DocAliasNum) !== -1) {
                  // SETA O TEXTO DO BOTÃO
                  botaoNFS.texto = 'RPS ' + vetor[index].virtual_s_doc[indexN].s_doc_rps_n + ' s. ' + vetor[index].virtual_s_doc[indexN].s_doc_rps_s
  
                  // SETA AS CLASSES DO BOTÃO
                  botaoNFS.class = 'btn btn-sm btn-warning'
                } else {
                  // SETA O TEXTO DO BOTÃO
                  botaoNFS.texto = vetor[index].virtual_s_doc[indexN].s_doc_tp + ' ' + vetor[index].virtual_s_doc[indexN].DocAliasNum
  
                  // SETA AS CLASSES DO BOTÃO
                  botaoNFS.class = 'btn btn-sm btn-primary'
                }
  
                // ADICIONA O BOTÃO NA TABELA
                vetor[index].doc_servico.push(botaoNFS)
              }
            }

            // VERIFICA SE TEM PRE NOTA
            if (vetor[index].doc_servico.length === 0) {
              vetor[index].doc_servico = null
            }
          }

          // VERIFICA SE DEVE COLOCAR COLUNA DE STATUS DO PROCESSO
          vetor[index].status_processo = null
          if ([ '', null, undefined ].indexOf(vetor[index].id_pco_item) === -1) {
            vetor[index].status_processo = {
              tipo: 'venda',
              id: vetor[index].id_pco_item,
              nome: vetor[index].id_pco_item_nome,
              cor_letra: FUN_VERIFICA_COR_LETRA(vetor[index].id_pco_item_cor_fundo),
              cor_fundo: vetor[index].id_pco_item_cor_fundo
            }
          }

          // CHAMA A FUNÇÃO PARA MONTAR OS BOTÕES DA COLUNA CHECKBOX
          vetor[index].col_check = this.demandaGerTabValidarCheckbox(vetor[index])

          // FAZ O CHECK DA COLUNA ID
          vetor[index]._check_col__id = vetor[index].col_check.length === 0

          // SETA OS DADOS DO BOTÃO
          vetor[index].n_nf_emitidas = ''
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demandaGerTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA A VARIAVEL PARA FILTRAR OS DADOS DA VENDA
        var optionsVen = []

        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // ADICIONA O OPTIONS
        optionsVen = optionsVen.concat([
          { id: 'codigo',       nome: 'Código' },
          { id: 'status',       nome: 'Status' },
          { id: 'last_at',      nome: 'Vencimento' },
          { id: 'last_user',    nome: 'Alterado pelo usuário' }
        ])

        // FILTROS DE OBSERVACAO
        if (this.cpntDemanda === 'compra') {

          optionsVen.push({ id: 'dem_obs',         nome: 'Obs. Fornecedor' })
          optionsVen.push({ id: 'dem_obs_nf',      nome: 'Obs. NF Produto' })
          optionsVen.push({ id: 'dem_obs_emp',     nome: 'Obs. Empresa' })

        } else if (this.cpntDemanda === 'dev_fornecedor') {

          optionsVen.push({ id: 'obs',         nome: 'Obs. NF' })
          // optionsVen.push({ id: 'obs_nf_pro',  nome: 'Obs. NF Produto' })
          optionsVen.push({ id: 'obs_emp',     nome: 'Obs. Empresa' })

        } else if (this.cpntDemanda === 'dev_cliente') {

          optionsVen.push({ id: 'obs',         nome: 'Obs. NF' })
          // optionsVen.push({ id: 'obs_nf_pro',  nome: 'Obs. NF Produto' })
          optionsVen.push({ id: 'obs_emp',     nome: 'Obs. Empresa' })

        } else {

          optionsVen.push({ id: 'obs_cli',     nome: 'Obs. Cliente' })
          optionsVen.push({ id: 'obs_nf_pro',  nome: 'Obs. NF Produto' })
          optionsVen.push({ id: 'obs_emp',     nome: 'Obs. Empresa' })

        }

        // SETA O FILTRO ALIAS
        if (this.cpntDemanda === 'venda' && [ '', null, undefined ].indexOf(this.$store.state.licenca.j_alias) === -1) {
          optionsVen.push({ id: 'alias', nome: 'Alias' })
        }

        // VERIFICA SE TEM PACOTE FINANCEIRO
        if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) === -1 && this.acessos.Financeiro === true) {
          optionsVen.push({ id: 'financeiro', nome: 'Financeiro' })
        }

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { slot: 'contato', group: 'Contato', mask: 'id_con' }
        ]     

        // VERIFICA SE ESTÁ NA TELA DE VENDA
        if (this.cpntDemanda === 'venda') {
          // VERIFICA SE TEM PACOTE VEICULO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
            vetor.options.push({ slot: 'veiculo', group: 'Veículo', mask: 'id_vei' })
          }
  
          // VERIFICA SE TEM PACOTE VEICULO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, null, null, null, null, false) === true) {
            vetor.options.push({ slot: 'pet', group: 'Pet', mask: 'id_pet' })
          }
        }

        // INICIA A VARIAVEL
        var optionNF = []

        // VERIFICA O FILTRO DE NOTA FISCAL
        if (this.acessos.NFe === true || this.acessos.NFCe === true || this.acessos.NFSe === true) {
          // VERIFICA SE TEM O MODULO DE NF-E
          if (this.acessos.NFe === true) {
            optionNF.push({ id: 'NFe', nome: 'NF-e'  })
          }

          // VERIFICA SE TEM O MODULO DE NFC-E
          if (this.acessos.NFCe === true) {
            optionNF.push({ id: 'NFCe', nome: 'NFC-e'  })
          }

          // VERIFICA SE TEM O MODULO DE NFS-E
          if (this.acessos.NFSe === true) {
            optionNF.push({ id: 'NFSe', nome: 'NFS-e'  })
          }
        }

        // CRIA A O FILTRO PARA NF DE FORNECEDOR
        if (this.cpntDemanda === 'compra') {
          optionNF.push({ id: 'NFeFornecedor', nome: 'NF-e Fornecedor' })
          optionNF.push({ id: 'NFCeFornecedor', nome: 'NFC-e Fornecedor' })
        }

        // ADICIONA OS OPTIONS
        if (optionNF.length >= 2) {
          vetor.options.push({ optgroup: 'Nota Fiscal', options: optionNF })
        } else if (optionNF.length >= 1) {
          vetor.options = vetor.options.concat(optionNF)
        }

        // SETA A OPÇÃO DE CONTROLE DE PROCESSOS
        if (this.cpntDemanda === 'venda' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 11 ], null, null, null, null, null, false) === true) {
          optionsVen.push({ id: 'pco', nome: 'Controle de processos' })
        }

        // SETA OS DADOS DA VENDA
        switch (this.cpntDemanda) {
          case 'venda':
            vetor.options.unshift({ optgroup: 'Venda', options: optionsVen })
            break
        
          case 'compra':
            vetor.options.unshift({ optgroup: 'Compra', options: optionsVen })
            break
        
          case 'dev_cliente':
            // ADICIONA O FILTRO DE CODIGO DE REFERENCIA
            optionsVen.push({ id: 'dem_ref', nome: 'Venda Referenciada Código' })

            // SETA AS OPÇÕES DO FILTRO DE DEVOLUÇÃO
            vetor.options.unshift({ optgroup: 'Dev Cliente', options: optionsVen })
            break

          case 'dev_fornecedor':
            // ADICIONA O FILTRO DE CODIGO DE REFERENCIA
            optionsVen.push({ id: 'dem_ref', nome: 'Compra Referenciada Código' })

            // SETA AS OPÇÕES DO FILTRO DE DEVOLUÇÃO
            vetor.options.unshift({ optgroup: 'Dev Fornecedor', options: optionsVen })
            break
        }

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      demandaGerTabOnBuscarOptionsFiltroO: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'status':
          case 'pco':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: '= Igual',          _formatar: [ 'id' ] },
              { id: '<>',   nome: '<> Diferente',     _formatar: [ 'id' ] },
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break

          case 'financeiro':
          case 'codigo':
          case 'dem_ref':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: '=',          _formatar: [ 'id' ] }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break

          case 'last_user':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: 'in',     nome: 'Igual' },
              { id: 'notIn',  nome: 'Diferente' }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = 'in'
            break
          
          case 'last_at':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: 'Igual' },
              { id: '<>',   nome: 'Diferente' }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break

          case 'NFe':
          case 'NFCe':
          case 'NFSe':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: 'sit',    nome: 'Situação' },
              { id: 'doc',    nome: 'Número' }
            ]

            // ADICIONA A OPÇÃO OPERAÇÃO PARA NOTA DE ENTRADA E SAIDA
            if (valor.f === 'NFe') {
              vetor.options.push({ id: 'ope', nome: 'Operação' })
            }

            // SETA O VALOR SELEICONADO
            vetor.value = 'sit'
            break

          case 'NFeFornecedor':
          case 'NFCeFornecedor':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: 'Igual',          _formatar: [ 'id' ] },
              { id: 'doc',    nome: 'Número' }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break

          case 'alias':
            vetor.options = [
              { id: '=',    nome: 'Igual' }
            ]
            break

          case 'obs_cli':

            vetor.options = [
              { id: '%64',    nome: '% Contém' }
            ]
            break;

          case 'obs':
          case 'obs_emp':
          case 'obs_nf_pro':

            vetor.options = [
              { id: this.cpntDemanda === 'venda' ? '%64' : '%',    nome: '% Contém' }
            ]
            break

          case 'dem_obs':
          case 'dem_obs_nf':
          case 'dem_obs_emp':

            vetor.options = [
              { id: '%',    nome: '% Contém' }
            ]
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      demandaGerTabOnBuscarOptionsFiltroV: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = { disabled: false }

        // INICIA A FUNÇÃO PARA FINALIZAR
        var finalizar = null

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'codigo':
          case 'dem_ref':
          case 'obs_cli':
          case 'obs':
          case 'obs_emp':
          case 'obs_nf_pro':
          case 'dem_obs':
          case 'dem_obs_nf':
          case 'dem_obs_emp':
            vetor.tipo = 'input'
            break

          case 'status':
            // SETA O OPTION DO SELETOR
            if (this.cpntDemanda === 'compra') {
              vetor.options = [
                { id: 'demanda',      nome: 'Compra' },
                { id: 'orcamento',    nome: 'Orçamento' },
              ]
            } else {
              vetor.options = [
                { id: 'demanda',      nome: 'Venda' },
                { id: 'orcamento',    nome: 'Orçamento' },
              ]
            }

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break

          case 'last_at':
            vetor = Object.assign(vetor, {
              multiple: false,
              tipo: 'seletor-data',
              optionInicialNome: '',
              value: '30'
            })
            break

          case 'NFeFornecedor':
            switch(valor.o) {
              case '=':
                // SETA O OPTION DO SELETOR
                vetor.options = [
                  { id: 's', nome: 'Apenas NFe Fornecedor' },
                  { id: 'n', nome: 'Não Mostrar NFe Fornecedor' } 
                ]

                // SETA O VALOR SELEICONADO
                vetor.value = '1'
                break

              case 'doc':
                vetor = Object.assign(vetor, {
                  tipo: 'input',
                  value: ''
                })
                break
            }
            break

          case 'NFCeFornecedor':
            switch(valor.o) {
              case '=':
                // SETA O OPTION DO SELETOR
                vetor.options = [
                  { id: 's', nome: 'Apenas NFCe Fornecedor' },
                  { id: 'n', nome: 'Não Mostrar NFCe Fornecedor' } 
                ]

                // SETA O VALOR SELEICONADO
                vetor.value = '1'
                break

              case 'doc':
                vetor = Object.assign(vetor, {
                  tipo: 'input',
                  value: ''
                })
                break
            }
            break

          case 'financeiro':
            // SETA O OPTION DO SELETOR
            if (this.cpntDemanda === 'compra') {
              vetor.options = [
                { id: 's',    nome: 'Compra no financeiro' },
                { id: 'n',    nome: 'Compra sem financeiro' },
              ]
            } else {
              vetor.options = [
                { id: 's',    nome: 'Venda no financeiro' },
                { id: 'n',    nome: 'Venda sem financeiro' },
              ]
            }

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break

          case 'pco':
            // SETA A VARIAVEL
            finalizar = ''

            // FAZ A BUSCA DOS DADOS
            this.demandaGerTabOnBuscarOptionsFiltroVControleProcesso((retorno) => {
              // SETA OS OPTIONS RECEBIDOS
              vetor.options = retorno

              // SETA OS DADOS DA TABELA MULTIPLA ESCOLHA
              vetor.tab = {
                limparOptions: false,
                coluna: [
                  { mPer: 1, chave: 'id_pco_status_nome', nome: 'Lista de status' },
                  { mPer: 1, chave: 'nome', nome: 'Status' },
                  { mPer: 1, chave: 'botao', nome: 'Excluir' }
                ],
                linha: [],
                notIn: []
              }
              
              // RETORNA O VALOR MONTADO
              callback(vetor)
            })
            break

          case 'last_user':
            // SETA A VARIAVEL
            finalizar = ''

            // FAZ A BUSCA DOS DADOS
            this.demandaGerTabBuscarUsuarios((options) => {
              vetor = Object.assign(vetor, {
                options: options,
                keyValue: 'id',
                keyMostra: [ 'usuario' ],
                tab: {
                  limparOptions: false,
                  coluna: [
                    { mPer: 1, chave: 'usuario', nome: 'Nome' },
                    { mPer: 1, chave: 'botao', nome: 'Excluir' }
                  ],
                  linha: [],
                  notIn: []
                }
              })

              // RETORNA O VALOR MONTADO PARA O CAMPO
              callback(vetor)
            })
            break

          case 'NFe':
          case 'NFCe':
          case 'NFSe':
            switch(valor.o) {
              case 'ope':
                // SETA O OPTION DO SELETOR
                vetor.options = [
                  { id: '1', nome: '1 - Saída' },
                  { id: '0', nome: '0 - Entrada' } 
                ]

                // SETA O VALOR SELEICONADO
                vetor.value = '1'
                break

              case 'sit':
                // SETA A VARIAVEL
                finalizar = ''

                // CARREGA OS VALORES 
                this.demandaGerTabBuscarStausNotas(JSON.parse(JSON.stringify(vetor)), valor, callback)
                break

              case 'doc':
                vetor = Object.assign(vetor, {
                  tipo: 'input',
                  value: ''
                })
                break
            }
            break

          case 'alias':
            // MONTA O SELETOR
            vetor = Object.assign(vetor, {
              tipo: 'select',
              value: ''
            })

            // CRIA OS OPTIONS
            vetor.options = [ { id: '0', nome: this.$store.state.licenca.rSocial } ]

            // ADICIONA OS ALIAS RECEBIDOS
            for (var indexA in this.$store.state.licenca.j_alias) {
              vetor.options.push({ id: this.$store.state.licenca.j_alias[indexA].id.toString(), nome: this.$store.state.licenca.j_alias[indexA].nome })
            }
            break
        }
        
        // RETORNA O VALOR MONTADO
        if (finalizar === null && Object.keys(vetor).length >= 2) {
          callback(vetor)
        }
      },
      demandaGerTabOnBuscarOptionsFiltroVControleProcesso: function (callback, registros = [], total = null) {
        if (total === null || registros.length < total) {
          // INICIA O QUERYGET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 2 } }
  
          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = {
            id: null,
            id_pco_status: { j: { nome: null } },
            nome: null,
            cor: null,
            painel_mostrar: null,
            posicao: null
          }
  
          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [
            { f: 'status', o: '=', v: '1' },
            { m: 'pco_status', f: 'status', o: '=', v: '1' }
          ] }
  
          // FAZ A ORDENAÇÃO DOS CAMPOS
          queryGet.order = { posicao: 'asc', id: 'asc' }
  
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/con-processo/config/sta-item/get/', 'GET', queryGet, (retorno) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(retorno.data)

            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.demandaGerTabOnBuscarOptionsFiltroVControleProcesso(callback, registros, Number(retorno.countAll))
          }, this.demandaGerTabSetarStatusGeral)
        } else {
          // INICIA OS OPTIONS
          var options = {}

          // INICIA O VALOR DO CAMPO
          for (var indexR in registros) {
            // PEGA O CODIGO DA LISTA
            var pco_lista = '_' + registros[indexR].id_pco_status

            // INICIA A VARIAVEL 
            if ([ '', null, undefined ].indexOf(options[pco_lista]) !== -1) {
              options[pco_lista] = { optgroup: registros[indexR].id_pco_status_nome, options: [] }
            }

            // ADICIONA O VALOR NO VETOR
            options[pco_lista].options.push(registros[indexR])
          }

          // RETORNA O VALOR CALCULADO
          callback(Object.values(options))
        }
      },
      demandaGerTabBuscarUsuarios: function (callback) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, usuario: null } }

        // SETA BUSCA QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'usuario', o: '<>', v: 'SuporteRF' } ] }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/usuario/get', 'POST', queryGet, (retorno) => {
          callback(retorno.data)
        }, this.demandaGerTabSetarStatusGeral)
      },
      demandaGerTabCopiar: function () {
        if (this.checkbox.length <= 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (this.checkbox.length >= 2) {
          this.$store.state.msgWarn('WEB [406]: Só é possivel copiar uma venda de cada vez.', 'warning')
        } else {
          // INICIA A VARIAVEL
          var queryGet = { type: 'list', limit: { row: 0, qty: 1 } }

          // SETA OS CAMPOS QUE SERÁ MANDADO PARA ATUALIZAR A NOVA VENDA
          queryGet.field = {
            cod_venda: null,
            id_con: null,
            id_pet: null,
            id_vei: null,
            obs_cli: null,
            obs_nf_pro: null,
            obs_emp: null
          }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [
            { f: 'status', o: '<>', v: '3' },
            { f: 'cod_venda', o: '=', v: this.checkbox[0] }
          ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/venda/get', 'POST', queryGet, (retorno) => {
            if (retorno.data.length === 0) {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.msgWarn('WEB [406]: Venda (' + this.checkbox[0] + ') informada não foi localizada.', 'warning')
  
              // ALTERA PARA TELA DE VENDAS GERENCIAR
              this.demandaGerTabBuscarLinhas()
            } else {
              // SETA OS PARAMETROS QUE SERÁ ENVIADO
              var params = { tipo: 'DEMANDA_NOVA', cadastro: 'contato', demanda: 'venda', paramsId: 1, redirecionar: false }
  
              // SETA O CALLBACK QUE DEVE EXECUTAR
              params.callback = (atualizar, id) => {
                if (atualizar === true) {
                  // SETA O FORMULARIO QUE SERÁ ENVIADO PARA ATUALIZAÇÃO
                  var formData = JSON.parse(JSON.stringify(retorno.data[0]))

                  // MANDA ATUALIZAR OS DADOS DA VENDA
                  this.demandaGerTabCopiarAtualizarDemanda(this.checkbox[0], id, formData)
                }
              }
  
              // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
              this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
            }
          }, this.demandaGerTabSetarStatusGeral)
        }
      },
      demandaGerTabCopiarAtualizarDemanda: function (cod_venda_ref, cod_venda_nova, formData) {
        // REMOVE A CHAVE QUE NÃO DEVE APRESENTAR
        if ([ '', null, undefined, '0' ].indexOf(formData.id_pet) !== -1 || this.acessos.pet === false) {
          delete formData.id_pet
        }

        // REMOVE A CHAVE QUE NÃO DEVE APRESENTAR
        if ([ '', null, undefined, '0' ].indexOf(formData.id_vei) !== -1 || this.acessos.veiculo === false) {
          delete formData.id_vei
        }

        // SETA O NOVO ID DA VENDA A SER ATUALIZADO
        formData.cod_venda = cod_venda_nova

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/venda', 'PUT', formData, () => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.msgWarn('WEB [200]: Venda atualizada com sucesso.', 'success')

          // EXECUTA O CALLBACK RECEBIDO
          this.demandaGerTabCopiarItensDemanda(cod_venda_ref, cod_venda_nova)
        }, this.demandaGerTabSetarStatusGeral, (apiValid, apiStatus) => {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, {}, this)
        })
      },
      demandaGerTabCopiarItensDemanda: function (cod_venda_ref, cod_venda_nova, index = 0, registros = { produto: [], servico: [] }, total = null, tipos = [ 'produto', 'servico' ]) {
        // PEGA O NOME DO REGISTRO A SER PROCESSADO
        var chave = tipos[index]

        // INICIA A VARIAVEL
        var router = ''
        var method = 'POST'

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if (chave === undefined) {
          this.$router.push({ name: 'venda_numero', params: { id: cod_venda_nova } })
        } else if (total === null || registros[chave].length < total) {
          // INICIA A VARIAVEL
          var queryGet = { type: 'list', limit: { row: registros[chave].length, qty: 1000 } }

          // SETA O NOME DA ROTA QUE DEVE EXECUTAR
          router = '/venda/' + chave + '/get'

          // VERIFICA O QUE DEVE CHAMAR
          switch (chave) {
            case 'produto':
              queryGet.field = {
                id_pro: null,
                qtde: null,
                valor_uni: null,
                // id_pco_item: { j: { id_pco_status: null } }
              }
              break
          
            case 'servico':  
              queryGet.field = {
                id_ser: null,
                qtde: null,
                valor_uni: null,
                // id_pco_item: { j: { id_pco_status: null } }
              }
              break;
          }
  
          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [
            { f: 'status', o: '=', v: '1' },
            { f: 'cod_venda', o: '=', v: cod_venda_ref }
          ] }
  
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, method, queryGet, (retorno) => {
            // SETA OS DADOS RECEBIDOS
            registros[chave] = registros[chave].concat(retorno.data)

            // REINICIA O PROCESSO DE BUSCA
            this.demandaGerTabCopiarItensDemanda(cod_venda_ref, cod_venda_nova, index, registros, Number(retorno.countAll))
          }, this.demandaGerTabSetarStatusGeral)
        } else if (registros[chave].length >= 1) {
          // SETA O NOME DA ROTA QUE DEVE EXECUTAR
          router = '/venda/' + chave

          // INICIA A VARIAVEL QUE SERÁ ENVIADA PARA API
          var formData = []
          
          // MONTA O INSERT DE CADA PRODUTO
          for (var indexL in registros[chave]) {
            // INICIA A VARIAVEL DO ITEM
            var item = {}
  
            // ADICIONA O CODIGO DA VENDA
            item.cod_venda = cod_venda_nova
  
            // ADICIONA OS VALORES RECEBIDOS
            for (var indexC in registros[chave][indexL]) {
              if ([ 'id_pro', 'id_ser', 'qtde', 'valor_uni', 'id_pco_status' ].indexOf(indexC) !== -1) {
                item[indexC] = registros[chave][indexL][indexC]
              }
            }
  
            // ADICIONA O ITEM AO VETOR QUE SERÁ ENVIADO PARA API
            formData.push(item)
          }

          // PEGA OS DADOS PARA INSERIR NA API
          formData = { lot: formData }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'POST', formData, () => {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.msgWarn('WEB [200]: ' + chave + ' inseridos com sucesso na venda (' + cod_venda_nova + ').', 'success')
            
            // REINICIA O PROCESSO DE BUSCA
            this.demandaGerTabCopiarItensDemanda(cod_venda_ref, cod_venda_nova, (index + 1), registros)
          }, this.demandaGerTabSetarStatusGeral, (apiValid, apiStatus) => {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, {}, this)
          })
        } else {
          this.demandaGerTabCopiarItensDemanda(cod_venda_ref, cod_venda_nova, (index + 1), registros)
        }
      },
      demandaGerTabExcluir: function () {
        // INICIA A VARIAVEL QUE VAI RECEBER A ROTA
        var router = ''
        var mensagem = ''
        var confirm = ''

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'venda':
            router = '/venda'
            mensagem = 'API [200]: Venda' + (this.checkbox.length >= 2 ? 's' : '') + ' excluída' + (this.checkbox.length >= 2 ? 's' : '') + ' com sucesso.'
            confirm = 'Deseja realmente excluir a(s) venda(s) selecionada(s)?'
            break

          case 'dev_cliente':
            router = '/demanda/dem-dev-cliente'
            mensagem = 'API [200]: ' + (this.checkbox.length >= 2 ? 'Devoluções' : 'Devolução') + ' excluída' + (this.checkbox.length >= 2 ? 's' : '') + ' com sucesso.'
            confirm = 'Deseja realmente excluir a(s) devoluçao(ões) selecionada(s)?'
            break

          case 'dev_fornecedor':
            router = '/demanda/dem-dev-fornecedor'
            mensagem = 'API [200]: ' + (this.checkbox.length >= 2 ? 'Devoluções' : 'Devolução') + ' excluída' + (this.checkbox.length >= 2 ? 's' : '') + ' com sucesso.'
            confirm = 'Deseja realmente excluir a(s) devoluçao(ões) selecionada(s)?'
            break

          case 'compra':
            router = '/demanda/dem-compra'
            mensagem = 'API [200]: ' + (this.checkbox.length >= 2 ? 'Compras' : 'Compra') + ' excluída' + (this.checkbox.length >= 2 ? 's' : '') + ' com sucesso.'
            confirm = 'Deseja realmente excluir a(s) compra(s) selecionada(s)?'
            break
        }

        // VERIFICA SE PODE EXCLUIR
        if (this.checkbox.length <= 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm(confirm)) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CRIA O FORMUARIO QUE SERÁ ENVIADO PARA API
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'DELETE', formData, (retorno) => {
            // APRESENTA A MENSAGEM RECEBIDA AO USUARIO
            this.$store.state.TRATAR_RET_LOT_API(retorno, null, mensagem)

            // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
            this.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA ATUALIZAR OS TOTAIS DA VENDA
            this.demandaGerTabBuscarLinhas()

            // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS DO MENU
            this.$store.commit('SET_INFO_MENU')
          }, this.demandaGerTabSetarStatusGeral)
        }
      },
      demandaGerTabBuscarStausNotas: function (vetor, valor, callback) {
        // PEGA O OPTIONS PARA O SELETOR
        switch (valor.f) {
          case 'NFCe':
            vetor.options = this.$store.state.codRetSefaz.filter(item => item.tipo === 'NFCe')
            break

          case 'NFe':
            vetor.options = this.$store.state.codRetSefaz.filter(item => item.tipo === 'NFe')
            break

          case 'NFSe':
            vetor.options = this.$store.state.codRetSefaz.filter(item => item.tipo === 'NFSe')
            break
        }

        // SETA OS VALORES PARA O CAMPO
        vetor = Object.assign(vetor, {
          keyValue: 'ref',
          keyMostra: [ 'nome' ],
          tab: {
            limparOptions: false,
            coluna: [
              { mPer: 1, chave: 'nome', nome: 'Nome' },
              { mPer: 1, chave: 'botao', nome: 'Excluir' }
            ],
            linha: [],
            notIn: []
          }
        })

        // RETORNA O VALOR MONTADO PARA O CAMPO
        callback(vetor)
      },
      demandaGerTabIniciarEdicaoFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false) {
          if (tentativa <= 5) {
            if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
              this.$refs[chave].cpntRealizarFocus()
            } else {
              setTimeout(() => { this.demandaGerTabIniciarEdicaoFocusCampo(chave, (tentativa + 1)) }, 100)
            }
          }
        }
      },
      demandaGerTabEditar: function () {
        if (this.campoEditar.value !== this.campoEditar.valueIni) {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // COPIA O VETOR
          var vetor = this.campoEditar.extra

          // INICIA O VETOR
          var formData = {}

          // SETA O ID DO REGISTRO QUE ESTÁ SENDO EDITADO
          formData.clu_dependente = this.linha[vetor.indexL].clu

          // SETA O VALOR QUE DEVE ATUALIZAR
          formData[vetor.indexCV] = this.campoEditar.tipo === 'select' ? this.campoEditar.value[this.campoEditar.keyValue] : this.campoEditar.value

          // CONVERTE O VALOR PARA STRING
          formData[vetor.indexCV] = formData[vetor.indexCV].toString()

          // CONVERTE O VALOR EM LOT
          formData = { lot: [ formData ] }


          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/contador', 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
                this.demandaGerTabBuscarLinhas()
                break

              default:
                // PEGA A MENSAGEM RETORNADA
                var mensagem = []

                // VERIFICA SE É UM VETOR NA MENSAGEM
                if (typeof retorno.message === 'object') {
                  for (var indexR in retorno.message) {
                    mensagem.push(indexR + ' - ' + (typeof retorno.message[indexR] === 'string' ? retorno.message[indexR] : retorno.message[indexR].join(' ')))
                  }
                } else {
                  mensagem.push(retorno.message)
                }

                // SETA OS DADOS RECEBIDOS NO CAMPO
                this.campoEditar.mensagem = mensagem.join('<br/>')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
                break
            }
          }, this.demandaGerTabSetarStatusGeral)
        }
      },
      demandaGerTabFormatarData: function (valor, entrada = 'YYYY-MM-DD', saida = 'DD/MM/YYYY') {
        return moment(valor, entrada).format(saida)
      },
      demandaGerTabNomeAmbiente: function (valor) {
        switch (valor) {
          case '2':
            return 'Homologação'
          
          case '1':
            return 'Produção'

          default:
            return '<span class="emissor" style="color: red;">ERRO</span>'
        }
      },
      demandaGerTabNomeEmissor: function (valor) {
        // INICIA A VARIAVEL PARA RETORNO
        var retorno = '('

        // VERIFICA O VALOR QUE DEVE COLOCAR
        switch (valor) {
          case 'mi':
            retorno += 'Migrate'
            break
          
          case 'rf':
            retorno += 'Rotina Fácil'
            break

          default:
            retorno += '<span style="color: red;">ERRO</span>'
            break
        }

        // FECHA O PARENTESES
        retorno += ')'

        // RETORNA O VALOR MONTADO
        return retorno
      },
      demandaGerTabUltimoAcesso: function (vetor) {
        // INICIA A VARIAVEL PARA RETORNO
        var retorno = '---'

        // VERIFICA SE TEM VALOR RECEBIDO
        if ([ '', null, undefined ].indexOf(vetor) === -1) {
          // TRANSFORMA A DATA E MOMENT.JS
          vetor._updated_at_ptbr = moment(vetor.updated_at_ptbr, 'DD/MM/YYYY HH:mm:ss')

          // CALCULA A DIFERENÇA DAS DATAS
          vetor.diff = moment.duration(moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss').diff(vetor._updated_at_ptbr))

          // PEGA O NUMERO DE DIAS
          var days = parseInt(vetor.diff.asDays())

          // PEGA O NUMERO DE HORAS
          var hours = parseInt(vetor.diff.asHours())

          // CALCULA A QUANTIDADE DE HORAS
          hours = hours - days*24

          // PEGA O NUMERO DE MINUTOS
          var minutes = parseInt(vetor.diff.asMinutes())

          // CALCULA A QUANTIDADE DE MINUTOS
          minutes = minutes - (days*24*60 + hours*60)

          // LIMPA A VARIAVEL
          retorno  = ''
          retorno += '<span>'
          retorno += '<span class="usuario">' + vetor.usuario + ' (' + vetor.id_usu + ')' + '</span> em '
          retorno += '<span class="data">' + vetor.updated_at_ptbr.replace(' ', ' às ') + '</span>'
          retorno += '</span><br/>'
          if (days > 0 || hours > 0 || minutes > 0) {
            retorno += '<span class="' + (days >= 8 ? 'vermelho' : '') + ' diferenca">Hà '
            if (days > 0) {
              retorno += days + ' dia' + (days >= 2 ? 's' : '')
            } else if (hours > 0) {
              retorno += hours + ' hora' + (hours >= 2 ? 's' : '')
            } else if (minutes > 0) {
              retorno += minutes + ' minuto' + (minutes >= 2 ? 's' : '')
            }
            retorno += '</span>'
          }
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      demandaGerTabMontarBotaoDemandaDocTexto: function (linha, indexC = '') {
        // VERIFICA A CHAVE QUE DEVE TRATAR
        var chave = this.cpntDemanda

        // VERIFICA SE TEM QUE PEGAR OUTRO MODULO COMO REFERENCIA
        if (indexC !== '' && this.cpntDemanda === 'dev_cliente') {
          chave = 'venda'
        } else if (indexC !== '' && this.cpntDemanda === 'dev_fornecedor') {
          chave = 'compra'
        }

        // MONTA OS VALORES
        var valor = (([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1 && indexC !== '') ? linha.dem_ref : linha.dem_alias)

        // VERIFICA SE TEM VALOR A SER FORMATADO
        if ([ '', null, undefined ].indexOf(valor) !== -1) {
          valor = '0000'
        }

        // FORMATA O VALOR RECEBIDO
        valor = (valor.length <= 4 ? ('0000' + valor).slice(-4) : valor)

        // RETORNA O VALOR MONTADO
        switch (chave) {
          case 'venda':
            valor = ((linha.status === '2' ? 'V' : 'O') + ' ' + valor)
            break
        
          case 'compra':
            valor = ((linha.status === '2' ? 'C' : 'O') + ' ' + valor)
            break

          case 'dev_cliente':
            valor = ('DC ' + valor)
            break

          case 'dev_fornecedor':
            valor = ('DF ' + valor)
            break
        }

        // RETORNA O VALOR
        return valor
      },
      demandaGerTabMontarBotaoDemandaDocClasse: function (linha) {
        // MONTA OS VALORES
        var valor = []

        // RETORNA O VALOR MONTADO
        valor = (linha.status === '2' ? [ 'btn', 'btn-sm', 'btn-primary' ] : [ 'btn', 'btn-sm', 'btn-warning' ])

        // RETORNA O VALOR
        return valor
      },
      demandaGerTabFormatarValor: function (linha) {
        // INICIA O VALOR QUE SERÁ RETORNADO
        var valor = '0,00'

        // VERIFICA SE TEM VALOR PARA FORMATAR
        if ([ '', null, undefined ].indexOf(linha.virtual_total) === -1 && [ '', null, undefined ].indexOf(linha.virtual_total.geral) === -1 && [ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.geral.liquido) === -1) {
          valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.geral.liquido)
        }

        // RETORNA O VALOR MONTADO
        return 'R$ ' + valor
      },
      demandaGerTabGerarQtipValor: function (chave, linha, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs[chave]) !== -1) {
            setTimeout(() => { this.demandaGerTabGerarQtipValor(chave, linha, (tentativa + 1)) }, 1000)
          } else if (this.$refs[chave].className.indexOf('qtip-cpnt-tab-dem-ger') === -1) {
            // CRIA AS VARIAVEIS UTILIZADAS
            var valores = ''
            var valoresJoin = []
            var valor = '0,00'

            // VERIFICA SE TEM O CAMPO VIRTUAL
            if ([ '', null, undefined ].indexOf(linha.virtual_total) === -1) {     
              // VERIFICA SE TEM VALOR PARA FORMATAR
              if ([ '', null, undefined ].indexOf(linha.virtual_total.geral) === -1 && [ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.geral.liquido) === -1) {
                valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.geral.liquido)
              }
              
              // VERIFICA SE TEM SERVIÇO
              if ([ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.servico) === -1 && [ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.servico.total) === -1) {
                // INICIA O VALOR DO CAMPO
                valoresJoin = []
      
                // SETA O VALOR DO SERVIÇO
                valores += 'Serviços + ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.servico.total)
      
                // SETA OS VALORES DE DESCONTO
                if ([ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.servico.desconto) === -1) {
                  valoresJoin.push('Des. - ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.servico.desconto))
                }
      
                // SETA O ESPAÇO ENTRE OS CAMPOS
                if (valoresJoin.length >= 1) {
                  valores += ' (' + valoresJoin.join(' | ') + ')'
                }
      
                // DA ESPAÇO ENTRE OS VALORES
                valores += '<br><br>'
              }
              // VERIFICA SE TEM SERVIÇO
              if ([ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.produto.total) === -1) {
                // INICIA O VALOR DO CAMPO
                valoresJoin = []
      
                // SETA O VALOR DO PRODUTO
                valores += 'Produtos + ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.produto.total)
      
                // SETA OS VALORES DE FRETE
                if ([ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.produto.frete) === -1) {
                  valoresJoin.push('Fre. + ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.produto.frete))
                }
      
                // SETA OS VALORES DE SEGURO
                if ([ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.produto.seguro) === -1) {
                  valoresJoin.push('Seg. + ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.produto.seguro))
                }
      
                // SETA OS VALORES DE ODA
                if ([ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.produto.oda) === -1) {
                  valoresJoin.push('O.D.A. + ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.produto.oda))
                }
      
                // SETA OS VALORES DE DESCONTO
                if ([ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.produto.desconto) === -1) {
                  valoresJoin.push('Des. - ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.produto.desconto))
                }
      
                // SETA O ESPAÇO ENTRE OS CAMPOS
                if (valoresJoin.length >= 1) {
                  valores += ' (' + valoresJoin.join(' | ') + ')'
                }
      
                // DA ESPAÇO ENTRE OS VALORES
                valores += '<br><br>'
              }
      
              // SETA O TOTAL BRUTO DA VENDA
              valores += 'Total Bruto ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.geral.total)
      
              // DA ESPAÇO ENTRE OS VALORES
              valores += '<br><br>'
      
              if (linha.virtual_total.geral.hasOwnProperty('desconto') && linha.virtual_total.geral.desconto !== '0') {
                // SETA O VALOR TOTAL DE DESCONTOS
                valores += 'Desconto total -' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.geral.desconto)
      
                // DA ESPAÇO ENTRE OS VALORES
                valores += '<br><br>'
              }
      
              if (linha.virtual_total.geral.hasOwnProperty('retencao') && linha.virtual_total.geral.retencao !== '0') {
                // SETA O VALOR TOTAL DE RETENÇOES
                valores += 'Retenção Serviços -' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.geral.retencao)
      
                // DA ESPAÇO ENTRE OS VALORES
                valores += '<br><br>'
              }
      
              if (linha.virtual_total.geral.hasOwnProperty('creDevolucao') && linha.virtual_total.geral.creDevolucao !== '0') {
                // SETA O VALOR TOTAL DE RETENÇOES
                valores += 'Crédito Devolução -' + this.$store.state.FUN_MASK_VALOR('valorMoeda', linha.virtual_total.geral.creDevolucao)
      
                // DA ESPAÇO ENTRE OS VALORES
                valores += '<br><br>'
              }
      
              // SETA O VALOR TOTAL LIQUIDO DA VENDA
              valores += 'Líquido ' + valor
            }

            // REMOVE O QTIP ANTIGO DO CAMPO
            $(this.$refs[chave]).qtip('destroy')

            // VERIFICA SE O VALOR FOI PREENCHIDO
            if (valores !== '') {
              // ADICIONA A CLASS A DIV
              this.$refs[chave].classList.add('qtip-cpnt-tab-dem-ger')
  
              // CRIA O QTIP PARA O CAMPO
              $(this.$refs[chave]).qtip({
                content: { text: valores },
                position: { my: 'top right', at: 'bottom left' },
                style: { classes: 'rf-qtip cpnt-qtip-icones qtip-cpnt-tab-dem-ger' }
              })
            }
          }
        }
      },
      demandaGerTabEditarVenda: function (dem_alias, buttonId) {
        // SETA O NOME DA ROTA QUE DEVE ABRIR
        var params = { name: '', params: { cts: this.$store.state.token.cts, id: dem_alias } }

        // VERIFICA O TIPO DE PAGINA QUE DEVE ABRIR
        switch (this.cpntDemanda) {
          case 'venda':
            params.name = 'venda_numero'
            break
        
          case 'compra':
            params.name = 'compra_numero'
            break

          case 'dev_cliente':
            params.name = 'dev_cliente_nova_numero'
            break

          case 'dev_fornecedor':
            params.name = 'dev_fornecedor_nova_numero'
            break
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if (this.$store.state.buttonClickScroll.indexOf(buttonId) !== -1) {
          this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank')
        } else {
          this.$router.push(params)
        }
      },
      demandaGerTabReciboDocumento: function (dem_alias, demanda) {
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: demanda, id: dem_alias, tipo: 'recibo', formato: 'html' } }).href, '_blank', {}, false)
      },
      demandaGerTabAbrirRecorrencia: function (id) {
        switch (this.cpntDemanda) {
          case 'compra':
            this.$store.state.OPEN_PAGE_CS(process.env.VUE_APP_URL_CS + '/app/compras/compra_agendamentos.php?cts=' + this.$store.state.token.cts + '&a=' + id, '_blank')
            break
          
          case 'venda':
            this.$store.state.OPEN_PAGE_CS(process.env.VUE_APP_URL_CS + '/app/vendas/venda_agendamentos.php?cts=' + this.$store.state.token.cts + '&a=' + id, '_blank')
            break
        }
      },
      demandaGerTabAbrirDocumentoFiscal: function (tipo, linha) {
        // INICIA A VARIAVEL
        var id = ''

        // VERIFICA O REGISTROS QUE DEVE BUSCAR
        switch (tipo) {
          case 'produto':
            id = linha.p_doc_docs
            break

          case 'servico':
            id = linha.s_doc_docs
            break
        }

        // SETA OS PARAMETROS A SEREM USADOS
        var params = { clu: this.$store.state.token.clu, a_id_df: [ id ], pdf: '1', xml: '0' }

        // VERIFICA A ORIGEM QUE ESTÁ SENDO SOLICITADA
        if ([ 'compra' ].indexOf(this.cpntDemanda) !== -1 && [ 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(linha.p_doc_tp) !== -1) {
          // SETA A NOVA CHAVE NO VETOR
          params.a_dem_compra_df_fornecedor = [ linha.dem_alias ]

          // REMOVE A CHAVE NÃO UTILIZADA
          delete params.a_id_df
        }

        // CRIA O LINK PARA ABERTURA DO DANFE
        var link = process.env.VUE_APP_DOC_FISCAL_ABR + '?t=' + encodeURIComponent(this.$store.state.FUN_CRIPTOGRAFIA('enc', params, process.env.VUE_APP_C32_KEY))

        // CHAMA FUNÇÃO PARA ABRIR OU IMPRIMIR A NOTA FISCAL
        this.$store.state.WEB_WINDOW_OPEN(link, '_blank')
      },
      demandaGerTabAbrirFinanceiro: function (id) {
        // INICIA A VARIAVEL
        var link = ''

        // SETA O LINK DO FINANCEIRO
        switch (this.cpntDemanda) {
          case 'compra':
            link = process.env.VUE_APP_URL_CS + '/app/financeiro/financeiro_rel.php?cts=' + this.$store.state.token.cts + '&cod_tp=11&cod_n=' + id
            break

          case 'venda':
            link = process.env.VUE_APP_URL_CS + '/app/financeiro/financeiro_rel.php?cts=' + this.$store.state.token.cts + '&cod_tp=10&cod_n=' + id
            break
        }

        // REDIRECIONA PARA TELA DO FINANCEIRO
        this.$store.state.OPEN_PAGE_CS(link, '_blank')
      },
      demandaGerTabAbrirComissao: function (id) {
        // SETA O LINK DO FINANCEIRO
        var link = this.$router.resolve({ name: 'comissao_busc', params: { cts: this.$store.state.token.cts, busca: window.btoa(JSON.stringify({ tipo: 'ven', id: id })) } }).href

        // REDIRECIONA PARA TELA DO FINANCEIRO
        this.$store.state.OPEN_PAGE_CS(link, '_blank')
      },
      demandaGerTabAbrirCadastro: function (tipo, id) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: tipo, id: id }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.demandaGerTabBuscarLinhas()
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      demandaGerTabAbrirTelaDocs: function (tipo, id) {
        // INICIA A VARIAVEL
        var link = ''

        // VERIFICA O TIPO QUE DEVE ABRIR
        switch (this.cpntDemanda + '__' + tipo) {
          case 'venda__produto':
            link = process.env.VUE_APP_URL_CS + '/app/df/docs.php?cts=' + this.$store.state.token.cts + '&t=' + window.btoa('10.p.' + id)
            break
          case 'venda__servico':
            link = process.env.VUE_APP_URL_CS + '/app/df/docs.php?cts=' + this.$store.state.token.cts + '&t=' + window.btoa('10.p.' + id + '.p..p.s')
            break

          case 'compra__produto':
            link = process.env.VUE_APP_URL_CS + '/app/df/docs.php?cts=' + this.$store.state.token.cts + '&t=' + window.btoa('11.p.' + id)
            break

          case 'dev_cliente__produto':
            link = process.env.VUE_APP_URL_CS + '/app/df/docs.php?cts=' + this.$store.state.token.cts + '&t=' + window.btoa('59.p.' + id)
            break

          case 'dev_fornecedor__produto':
            link = process.env.VUE_APP_URL_CS + '/app/df/docs.php?cts=' + this.$store.state.token.cts + '&t=' + window.btoa('60.p.' + id)
            break
        }

        // REDIRECIONA PARA TELA DO FINANCEIRO
        this.$store.state.OPEN_PAGE_CS(link, '_blank')
      },
      demandaGerTabAbrirControleProcesso: function (linha) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', id: linha.dem_alias, tipo: 'processo', modelo: 'venda' }
        
        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.demandaGerTabBuscarLinhas()
          }
        }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      demandaGerTabValidarItemTemNotaProduto: function (linha) {
        return ([ '', null, undefined, '0', 0 ].indexOf(linha.p_doc_docs) === -1)
      },
      demandaGerTabValidarItemTemNotaServico: function (linha) {
        return [ '', null, undefined ].indexOf(linha.virtual_s_doc) === -1 && linha.virtual_s_doc.filter(item => [ '', null, undefined, '0', 0 ].indexOf(item.s_doc_docs) === -1).length >= 1
      },
      demandaGerTabValidarItemFinanceiro: function (linha) {
        return ([ '', null, undefined, '0' ].indexOf(linha.status_fin) === -1)
      },
      demandaGerTabValidarItemPDV: function (linha) {
        return ([ '', null, undefined ].indexOf(linha.pdv_senha) === -1 && Number(linha.pdv_senha) >= 1)
      },
      demandaGerTabValidarItemComissao: function (linha) {
        return ([ '', null, undefined, '0' ].indexOf(linha.cms_status) === -1)
      },
      demandaGerTabValidarItemCreditoDevolucao: function (linha) {
        return ([ '', null, undefined ].indexOf(linha.virtual_total) === -1 && [ '', null, undefined ].indexOf(linha.virtual_total.geral) === -1 && [ '', null, undefined, '0', 0 ].indexOf(linha.virtual_total.geral.creDevolucao) === -1)
      },
      demandaGerTabValidarCheckbox: function (linha) {
        // INICIA A VARIAVEL PARA BOTOES
        var vetor = []

        // VERIFICA SE TEM NOTA FISCAL DE PRODUTO VINCULADA
        if (this.demandaGerTabValidarItemTemNotaProduto(linha) === true) {
          vetor.push({
            tipo: 'button',
            status: '',
            icone: 'nota-fiscal',
            explica: { mensagem: 'Venda vínculada a uma ' + linha.p_doc_tp },
            disabled: (linha.p_doc_tp === 'NFe' && this.acessos.NFe === false) || (linha.p_doc_tp === 'NFCe' && this.acessos.NFCe === false),
            onClick: (_linha) => { this.demandaGerTabAbrirTelaDocs('produto', _linha.dem_alias) }
          })
        }

        // VERIFICA SE TEM NOTA FISCAL DE SERVIÇO VINCULADA
        if (this.demandaGerTabValidarItemTemNotaServico(linha) === true) {
          vetor.push({
            tipo: 'button',
            status: '',
            icone: 'nota-fiscal',
            explica: { mensagem: 'Venda vínculada a (' + linha.virtual_s_doc.length + ') NFSe.' },
            disabled: (linha.p_doc_tp === 'NFSe' && this.acessos.NFSe === false),
            onClick: (_linha) => { this.demandaGerTabAbrirTelaDocs('servico', _linha.dem_alias) }
          })
        }        

        // VERIFICA SE É UMA VENDA DO PDV
        if (this.demandaGerTabValidarItemPDV(linha) === true) {
          vetor.push({
            tipo: 'icone',
            status: '',
            icone: 'financeiro_pdv',
            explica: { mensagem: 'Já registrado no Financeiro' }
          })
          vetor.push({
            tipo: 'icone',
            status: '',
            icone: 'pdv',
            explica: { mensagem: 'Venda Gerada pelo PDV (Senha ' + linha.pdv_senha + ')' }
          })
        } else if (this.demandaGerTabValidarItemFinanceiro(linha) === true) {
          vetor.push({
            tipo: (this.acessos.Financeiro === true ? 'button' : 'icone'),
            status: '',
            icone: 'financeiro_pdv',
            explica: { mensagem: 'Já registrado no Financeiro' },
            onClick: (_linha) => { this.demandaGerTabAbrirFinanceiro(_linha.dem_alias) }
          })
        }

        // VERIFICA SE TEM FECHAMENTO DE COMISSÃO NESTA VENDA
        if (this.demandaGerTabValidarItemComissao(linha) === true) {
          vetor.push({
            tipo: 'button',
            status: '',
            icone: 'cms',
            explica: { mensagem: 'Venda com produtos ou serviços com fechamento de comissão realizado.' },
            onClick: (_linha) => { this.demandaGerTabAbrirComissao(_linha.dem_alias) }
          })
        }

        // VERIFICA SE TEM ALGUM CREDITO DE DEVOLUÇÃO LANÇADO
        if (this.demandaGerTabValidarItemCreditoDevolucao(linha) === true) {
          vetor.push({
            tipo: 'icone',
            status: '',
            icone: 'quadrado',
            explica: { mensagem: 'Crédito Devolução Utilizado' }
          })
        }



        // RETORNA SE PASSOU EM TODAS AS VERIFICAÇÕES
        return vetor
      },
      demandaGerTabMarcarCheckbox: function (checked, value) {
        // VERIFICA SE DEVE MARCAR OU DESMARCAR O CHECKBOX
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // REMOVER VALORES DUPLICADOS
        this.checkbox = this.checkbox.filter((v, i, a) => a.indexOf(v) === i)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demandaGerTabBuscarNfEmitidas: function (indexL, linha) {
        // SETA O STATUS DO BOTÃO
        this.linha[indexL].n_nf_emitidas = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // FAZ A BUSCA DOS DADOS NA API
        this.$store.state.comunicaAPI('/venda/subase/df-eve-mes-anterior/get/', 'GET', linha.cod_venda, (retorno) => {
          // INICIA A VARAIVEL
          var texto = []

          // MONTA OS TEXTOS QUE DEVEM SER APRESENTADO
          for (var indexC in retorno.data) {
            texto.push(indexC + ': <b>' + retorno.data[indexC] + '</b>')
          }
          
          // SETA O STATUS DO BOTÃO
          this.linha[indexL].n_nf_emitidas = '<div>' + texto.join('</br>') + '</div>'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, this.demandaGerTabSetarStatusGeral)
      },
      demandaGerTabGerarRelatorioConsolidado: function () {
        if (this.relConsolidadoPgto !== null) {
          // SETA OS FILTROS RECEBIDOS
          this.relConsolidadoPgto = null
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else {
          this.demandaGerTabMontarFiltros((filtros) => {
            // SETA OS FILTROS RECEBIDOS
            this.relConsolidadoPgto = filtros
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        }
      }
    },
    computed: {
      mostrarBotaoNovaDemanda: function () {
        switch (this.cpntDemanda) {
          case 'venda':
            return this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 13 ], null, false) === true
        
          case 'compra':
            return this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 19 ], null, false) === true

          default:
            return true
        }
      },
      nomeBotaoNovaDemanda: function () {
        // texto: (this.cpntDemanda === 'venda' ? 'Nova Venda' : 'Nova Compra'),
        switch (this.cpntDemanda) {
          case 'venda':
            return 'Nova Venda'
        
          case 'compra':
            return 'Nova Compra'

          case 'dev_cliente':
            return 'Nova Devolução Cliente'

          case 'dev_fornecedor':
            return 'Nova Devolução Fornecedor'

          default:
            return ''
        }
      }
    },
    watch: {
      'cpntDemanda': function () {
        // LIMPA VARIAVEL DE RESQUEST API VALIDAS
        this.$store.commit('SET_CANCEL_REQUEST_API')

        // SETA O STATUS DA TELA
        this.demandaGerTabSetarStatusGeral('carregando')

        // SETA O FLAG PARA ATUALIZAR O COMPONENT
        this.$store.commit('SET_TIME_CONTEUDO', true)
      },
      '$route': function (routeAtual, routeAnterior) {
        if (routeAnterior.name !== routeAtual.name) {
          // SETA O STATUS DA PAGINA
          this.demandaGerTabSetarStatusGeral('carregando')

          // LIMPA OS VALORES PARA NÃO APRESENTAR ERRADO
          this.checkbox = []
          this.where = {}
          this.linha = []
          this.colunas = []

          // MANDA ATUALIZAR A TABELA
          setTimeout(() => { this.demandaGerTabBuscarLinhas() }, 500)
        }
      }
    }
  }
</script>
